import { Formik } from 'formik'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import React, { useContext, useEffect, useRef, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import ReactQuill from 'react-quill'
import Select from 'react-select'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'
import { upsertDocument } from '@futures-platform/connectors/content-service-api'
import {
  handleImageUploadIfNeeded,
  uploadFile,
} from '@futures-platform/connectors/media-api'
import { getUsername } from '@futures-platform/connectors/session'
import {
  removeTagScenario,
  tagScenario,
} from '@futures-platform/connectors/tag-service-api'
import { useEditableGroups } from '@futures-platform/hooks'
import {
  getAvailableLanguages,
  getLanguage,
  requestTranslation,
} from '@futures-platform/i18n'
import {
  Input,
  Modal,
  SelectImageButton,
  SelectImageContainer,
  SelectImageInputContainer,
  paddingModalStyles,
  quillFormats,
  quillModules,
} from '@futures-platform/ui'
import { mdiTagPlus, mdiTagPlusOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { InfoCircle } from '@styled-icons/boxicons-regular'
import { fetcher } from '../../helpers/fetcher'
import { isDevEnv } from '../../helpers/helpers'
import { scenarioAPIs } from '../../helpers/scenarioApis'
import { ACTIONS } from '../../store/Actions'
import { DataContext } from '../../store/GlobalState'
import styles from '../../styles.module.css'
import CardFooter from '../CardFooter'
import DeleteConfirmationModal from '../DeleteConfirmationModal/DeleteConfirmationModal'
import InformationModal2 from '../InformationModal/InformationModal'
import MainActors from '../MainActors'
import RelatedScenarios from '../RelatedScenarios'
import { DriversImg } from '../RelatedScenarios/styles'
import WarningEditModal from '../WarningEditModal'
import { Actors } from './Actors'
import { DevelopmentPath } from './DevelopmentPath'
import HistoryEditor from './HistoryEditor'
import InformationModal from './InformationModal'
import PhenomenaSelector from './PhenomenaSelector'
import { PhenomenaTagList } from './PhenomenaTagList'
import { PhenomenaTagSelector } from './PhenomenaTagSelector'
import ScenariosSelector from './ScenariosSelector'
import ToggleSwitcher from './ToggleSwitcher'
import ToggleSwitcherForHistory from './ToggleSwitcherForHistory'
import { VerbalDrivers } from './VerbalDrivers'
import icon from './icons/scenarioset.svg'

const mediaURL = process.env.REACT_APP_MEDIA_API_URL
const SortableRelatedPhenomena = SortableElement(
  ({ relatedPhenom, onSelect }) => {
    // const {
    //   content: { title },
    // } = relatedPhenom
    const title = relatedPhenom?.content?.title
    return (
      <li
        className="d-flex align-items-center hoverable pt-1 pb-1 bg-white pl-1 pr-1"
        style={{ zIndex: 999, marginBottom: '1px' }}>
        <i className="material-icons mr-1" style={{ color: '#666' }}>
          swap_vert
        </i>
        <p className="mb-0">{title}</p>
        <button
          onClick={(e) => {
            e.preventDefault()
            onSelect(relatedPhenom)
          }}
          className="ml-auto material-icons"
          style={{ color: '#006998', flexShrink: 0 }}>
          cancel
        </button>
      </li>
    )
  },
)
const SortableRelatedPhenomenaList = SortableContainer(
  ({ relatedPhenomena, onSelect }) => {
    return (
      <ul className="pl-0" style={{ listStyleType: 'none' }}>
        {relatedPhenomena.map((relatedPhenom, index) => (
          <SortableRelatedPhenomena
            index={index}
            key={`related-${index}`}
            relatedPhenom={relatedPhenom}
            onSelect={onSelect}
          />
        ))}
      </ul>
    )
  },
)

export const WriteEditScenarioForm = ({
  // historyData,
  mutaterelatedPhenomena,
  scenario,
  scenarioId,
  scenarioSet,
  onCancel,
  onSubmit,
  tagList,
  relatedScenarios,
  data,
  mutateScenarioData,
  mutateTagsScenarioData,
  lastEditorId,
  relatedPhenomena,
  language,
  driversFuturesTables,
}) => {
  const {
    dispatch,
    state: {
      tags: activeTagListStore,
      isMainActorsDeactivated,
      isRelatedScenariosDeactivated,
      isTagsDeactivated,
      devPaths,
      verbalDrivers,
      actors,
      currentIndexEditingHistory,
      historyDataStore,
      orignaltags,
    },
  } = useContext(DataContext)
  const historyData = React.useMemo(() => {
    return [...historyDataStore]
  }, [historyDataStore])
  const [historyDataState, sethistoryDataState] = useState([...historyData])

  // const historyCountRef = useRef(0)
  // useEffect(() => {
  //   if (
  //     !historyDataState?.length &&
  //     !!historyData?.length &&
  //     historyCountRef?.current === 0
  //   ) {
  //     sethistoryDataState(() => [...historyData])
  //     historyCountRef.current = 1
  //   }
  // }, [historyData, historyDataState?.length])

  const [relatedPhenomenaState, setrelatedPhenomenaState] =
    useState(relatedPhenomena)
  const [iconHistorySection, seticonHistorySection] =
    React.useState('expand_more')
  const [isEditHistoryModalOpened, setisEditHistoryModalOpened] =
    useState(false)
  const [relatedScenariosState, setrelatedScenariosState] =
    useState(relatedScenarios)

  const isUpdate = !!scenarioId
  const gid = scenarioSet?.groupId || 0
  const [fileImg, setfileImg] = useState('')
  const [isShowDeleteHistoryModal, setisShowDeleteHistoryModal] =
    useState(false)
  const [tags, setTags] = useState(new Set(activeTagListStore))
  const [step1AnchorEl, setStep1AnchorEl] = useState(null)
  const [step2AnchorEl, setStep2AnchorEl] = useState(null)
  const [step1DescriptionDisplayed, setStep1DescriptionDisplayed] =
    useState(false)
  const [step2DescriptionDisplayed, setStep2DescriptionDisplayed] =
    useState(false)
  const [step1InformationModal, setStep1InformationModal] = useState(false)
  const onHoverStep1Icon = (event) => {
    setStep1AnchorEl(event.currentTarget)
    setStep1DescriptionDisplayed(true)
  }
  const [driversEditorInfo, setdriversEditorInfo] = useState(false)
  const [titleEditorInfo, settitleEditorInfo] = useState(false)
  const [shortTitleEditorInfo, setshortTitleEditorInfo] = useState(false)

  const [summaryEditorInfo, setsummaryEditorInfo] = useState(false)
  const [narrativeEditorInfo, setnarrativeEditorInfo] = useState(false)
  const [developmentPathEditorInfo, setdevelopmentPathEditorInfo] =
    useState(false)
  const [mainActorsEditorInfo, setmainActorsEditorInfo] = useState(false)
  const [relatedScenariosEditorInfo, setrelatedScenariosEditorInfo] =
    useState(false)
  const [relatedContentsEditorInfo, setrelatedContentsEditorInfo] =
    useState(false)
  const [tagsEditorInfo, settagsEditorInfo] = useState(false)
  const [historyEditorInfo, sethistoryEditorInfo] = useState(false)
  const [majorUpdate, setmajorUpdate] = useState({
    isMajorUpdate: false,
    description: '',
  })
  const [warningEditedWithin30Mins, setWarningEditedWithin30Mins] =
    useState(false)
  const [editorData, seteditorData] = useState(null)
  const [fieldsValuesChanged, setFieldsValuesChanged] = useState(scenario)
  const onLeaveStep1Icon = () => {
    setStep1AnchorEl(null)
    setStep1DescriptionDisplayed(false)
  }
  const openStep1InformationModalHandle = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setStep1InformationModal(true)
  }
  const closeStep1InformationModalHandle = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setStep1InformationModal(false)
  }
  const addOrRemoveTag = async (t) => {
    const tmpTags = new Set(tags)
    if (tags.has(t)) {
      tmpTags.delete(t)
      await removeTagScenario(gid, scenarioId, t)
    } else {
      tmpTags.add(t)
      await tagScenario(gid, scenarioId, t)
    }
    setTags(tmpTags)
  }

  const stripAllHtml = (html) => {
    if (!html) return '';
    let tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text/plain');
    const modifiedText = stripAllHtml(pastedText);
    document.execCommand('insertText', false, modifiedText);
  };

  const sanitizeWysiwyg = (html) => {
    html = html.replace(/&lt;[^&]*&gt;/g, '');
    return html;
  };

  const [lastEdited, setlastEdited] = useState()

  React.useEffect(() => {
    const userFetcher = async () => {
      const res = await fetcher.getUserName(editorData?.data?.updated_by)
      setlastEdited(() => res)
    }
    Number(lastEditorId) !== Number(editorData?.data?.updated_by) &&
      !!editorData?.data?.updated_by &&
      userFetcher()
  }, [editorData?.data?.updated_by, lastEditorId])

  const lastEditedTime = React.useMemo(() => {
    if (
      !editorData?.data?.updated_at ||
      Number(lastEditorId) === Number(editorData?.data?.updated_by)
    )
      return ''
    const castData = new Date(editorData?.data?.updated_at)
    const date = castData?.toLocaleDateString('en-US')?.split('/')
    return (
      castData?.toLocaleTimeString('en-US', {
        hour12: false,
      }) +
      ' ' +
      '(' +
      date[1] +
      '.' +
      date[0] +
      '.' +
      date[2] +
      ')'
    )
  }, [editorData?.data?.updated_at, editorData?.data?.updated_by, lastEditorId])

  const startingOverWriteScenario = async () => {
    if (
      !!fieldsValuesChanged.title?.length ||
      fieldsValuesChanged.title !== ''
    ) {
      try {
        const phenomenonInput = {
          ...fieldsValuesChanged,
        }
        const storedImg =
          !!fileImg && (await handleImageUploadIfNeeded(fileImg, gid))
        // (await scenarioAPIs.storeImgToDb(gid, fileImg))

        const devPathsTemp = [...devPaths]?.map((dp) => {
          return { description: dp?.description, year: dp?.year }
        })

        await saveScenario({
          ...fieldsValuesChanged,
          isMainActorsDeactivated,
          isRelatedScenariosDeactivated,
          isTagsDeactivated,
          developmentPath: devPathsTemp,
          media: {
            video: phenomenonInput?.video,
            image: !!storedImg
              ? `${storedImg}`
              : phenomenonInput?.imageUrl || '',
            text: phenomenonInput?.videoText,
          },
        })
        if (!!fieldsValuesChanged?.id) {
          const scenarioCardChangedFromSessionStorage = !sessionStorage.getItem(
            'scenarioCardChanged',
          )
            ? 0
            : Number(sessionStorage.getItem('scenarioCardChanged'))

          sessionStorage.setItem(
            'scenarioCardChanged',
            Number(scenarioCardChangedFromSessionStorage) + 1,
          )
          window.dispatchEvent(new Event('storage'))
        }
      } catch (error) {
        console.error(error.message)
      }
    }
  }

  const saveScenario = async (values) => {
    // const {
    //   isMainActorsDeactivated,
    //   isRelatedScenariosDeactivated,
    //   isTagsDeactivated,
    //   developmentPath,
    // } = values
    // scenarioAPIs.upsertScenarioCard({
    //   gid,
    //   doc: values,
    // })

    let saveRes = null
    const temp1 = !!devPaths?.length ? [...devPaths] : []
    const temp = temp1
      ?.map((d) => ({
        description: d?.description,
        year: d?.year,
      }))
      ?.sort((a, b) => a?.year - b?.year)
    const temp2 = temp1?.map((d) => ({
      description: d?.description,
      year: d?.year,
    }))
    const date = new Date()
    let day = date.getDate()
    let month = date.getMonth() + 1
    let year = date.getFullYear()
    // This arrangement can be altered based on how we want the date's format to appear.
    let currentDate = `${day}.${month}.${year}`

    const isMajorUpdateTemp = majorUpdate?.isMajorUpdate
    if (Number(gid) !== 0) {
      const payload = {
        id: scenario?.id,
        type: 'scenario-card',
        archived: false,
        language: values?.language || getLanguage() || 'en',
        groups: [gid],
        latestupdate_editorName: !!isMajorUpdateTemp
          ? Number(gid) !== 0
            ? String(getUsername())
            : 'Futures Platform'
          : values?.latestupdate_editorName || '',
        latestUpdate_v2: !!isMajorUpdateTemp
          ? new Date().getTime()
          : values?.latestUpdate_v2 || null,
        content: {
          short: values?.short,
          time_range: {
            min: !!temp?.length && temp?.length > 0 ? temp[0]?.year : 2023,
            max: !!temp?.length ? temp[Number(temp?.length) - 1]?.year : 2023,
          },
          scenarioSetId: scenarioSet?.id || 0,
          type:
            Number(gid) === 0
              ? 'fp-scenario'
              : scenarioSet?.type === 'futures_table'
              ? 'futures_table'
              : 'axes_of_uncertainty',
          title: values?.title,
          drivers: !!values?.drivers?.length
            ? [values?.drivers[0], values?.drivers[1]]
            : [],
          summary: values?.summary,
          narrative: values?.narrative,
          actors: actors || values?.actors,
          historyLogs: [
            ...historyDataState,
            {
              ...majorUpdate,
              editorName:
                Number(gid) !== 0 ? getUsername() : 'Futures Platform',
              isCreator: false,
              isShown: true,
              date: currentDate,
              id: new Date().getTime(),
              timestamp: new Date().getTime(),
            },
          ],
          // history: values?.history || '',
          developmentPath: [...temp2],
          media: {
            image:
              // imgURLTemp ||
              values?.media?.image || values?.imageUrl || values?.image,
            text: values?.media?.text || values?.videoText,
          },
          isMainActorsDeactivated: values?.isMainActorsDeactivated,
          isRelatedScenariosDeactivated: values?.isRelatedScenariosDeactivated,
          isTagsDeactivated: values?.isTagsDeactivated,
          related_phenomena: !!values?.relatedPhenomena?.length
            ? values?.relatedPhenomena?.map((r) => r?.id)
            : [],
          related_scenarios:
            (values?.relatedScenarios || relatedScenarios)?.map(
              (re_scenario) => {
                return re_scenario?.id
              },
            ) || [],
        },
      }
      saveRes = await upsertDocument({ ...payload, group: gid })
    } else {
      const payload = {
        id: scenario?.id,
        type: 'scenario-card',
        archived: false,
        language: values?.language || getLanguage() || 'en',
        groups: [gid],
        latestupdate_editorName: !!isMajorUpdateTemp
          ? Number(gid) !== 0
            ? String(getUsername())
            : 'Futures Platform'
          : values?.latestupdate_editorName || '',
        latestUpdate_v2: !!isMajorUpdateTemp
          ? new Date().getTime()
          : values?.latestUpdate_v2 || null,
        content: {
          historyLogs: [
            ...historyDataState,
            {
              ...majorUpdate,
              editorName:
                Number(gid) !== 0 ? getUsername() : 'Futures Platform',
              isCreator: false,
              isShown: true,
              date: currentDate,
              id: new Date().getTime(),
              timestamp: new Date().getTime(),
            },
          ],
          short: values?.short,
          time_range: {
            min: !!temp?.length && temp?.length > 0 ? temp[0]?.year : 2023,
            max: !!temp?.length ? temp[Number(temp?.length) - 1]?.year : 2023,
          },
          // scenarioSetId: scenarioSet?.id || 0,
          type: 'fp-scenario',
          title: values?.title,
          summary: values?.summary,
          narrative: values?.narrative,
          developmentPath: [...temp2],
          media: {
            image:
              // imgURLTemp ||
              values?.media?.image || values?.imageUrl || values?.image,
            text: values?.media?.text || values?.videoText,
          },
          isMainActorsDeactivated: values?.isMainActorsDeactivated,
          isRelatedScenariosDeactivated: values?.isRelatedScenariosDeactivated,
          isTagsDeactivated: values?.isTagsDeactivated,
          actors: actors || values?.actors,
          history: values?.history || '',
          verbalDrivers: verbalDrivers || values?.verbalDrivers,
          related_phenomena:
            (values?.relatedPhenomena || relatedPhenomena)?.map((r) => r?.id) ||
            [],
          related_scenarios:
            (values?.relatedScenarios || relatedScenarios)?.map(
              (re_scenario) => {
                return re_scenario?.id
              },
            ) || [],
        },
      }
      saveRes = await upsertDocument({ ...payload, group: gid })
    }

    const notIntersectionTags_ReturnFromOriginalTags =
      !!activeTagListStore?.length && !!orignaltags?.length
        ? orignaltags.filter((element) => !activeTagListStore.includes(element))
        : []

    const notIntersectionTags_ReturnFromNewTags =
      !!activeTagListStore?.length && !!orignaltags?.length
        ? activeTagListStore.filter((element) => !orignaltags.includes(element))
        : []

    if (
      !!notIntersectionTags_ReturnFromOriginalTags?.length &&
      notIntersectionTags_ReturnFromOriginalTags?.length > 0
    ) {
      try {
        await Promise.allSettled(
          !!notIntersectionTags_ReturnFromOriginalTags?.length &&
            notIntersectionTags_ReturnFromOriginalTags.map(async (tag) => {
              try {
                await fetcher.removeTagScenarioCard(gid, saveRes?.id, tag)
              } catch (err) {
                console.error(`I'm down, this time. ${err}`)
              }
            }),
        )
      } catch (error) {}
    }

    if (
      !!notIntersectionTags_ReturnFromNewTags?.length &&
      notIntersectionTags_ReturnFromNewTags?.length > 0
    ) {
      try {
        await Promise.allSettled(
          !!notIntersectionTags_ReturnFromNewTags?.length &&
            notIntersectionTags_ReturnFromNewTags.map(async (tag) => {
              try {
                await fetcher.tagScenarioCard(gid, saveRes?.id, tag)
              } catch (err) {
                console.error(`I'm down, this time. ${err}`)
              }
            }),
        )
      } catch (error) {}
    } else {
      if (!!activeTagListStore?.length && activeTagListStore?.length > 0)
        try {
          await Promise.allSettled(
            !!activeTagListStore?.length &&
              activeTagListStore.map(async (tag) => {
                try {
                  await fetcher.tagScenarioCard(gid, saveRes?.id, tag)
                } catch (err) {
                  console.error(`I'm down, this time. ${err}`)
                }
              }),
          )
        } catch (error) {}
    }

    await mutateScenarioData()
    await mutateTagsScenarioData()
    onSubmit()
    await mutaterelatedPhenomena()
  }

  const [iconTitleAndSummary, seticonTitleAndSummary] = useState('expand_more')
  const [iconScenarioNarrative, seticonScenarioNarrative] = useState(
    !!(scenario?.narrative || scenario?.body)?.length || !!devPaths?.length
      ? 'expand_more'
      : 'expand_less',
  )
  const [iconNarrative, seticonNarrative] = useState(
    !!(scenario?.narrative || scenario?.body)?.length
      ? 'expand_more'
      : 'expand_less',
  )
  const [iconDevPath, seticonDevPath] = useState(
    !!devPaths?.length ? 'expand_more' : 'expand_less',
  )
  const [iconVerbalDrivers, seticonVerbalDrivers] = useState(
    !!scenarioSet?.drivers?.length || !!verbalDrivers?.length
      ? 'expand_more'
      : 'expand_less',
  )

  const [iconRelatedNodeSection, seticonRelatedNodeSection] = useState(
    !!relatedPhenomenaState?.length ? 'expand_more' : 'expand_less',
  )
  const [iconRelatedSSSection, seticonRelatedSSSection] = useState(
    !!relatedScenariosState?.length && !isRelatedScenariosDeactivated
      ? 'expand_more'
      : 'expand_less',
  )
  const [iconTaggingSection, seticonTaggingSection] = useState(
    !!activeTagListStore?.length || !isTagsDeactivated
      ? 'expand_more'
      : 'expand_less',
  )
  const [iconActors, seticonActors] = useState(
    !!actors?.length ? 'expand_more' : 'expand_less',
  )

  const [isOpenTagSelectorModal, setisOpenTagSelectorModal] = useState(
    !!isUpdate ? false : true,
  )

  const [isTaggingSelectorOpened, setisTaggingSelectorOpened] = useState(
    !isTagsDeactivated,
  )
  const [isReviewModalOpened, setisReviewModalOpened] = useState(false)
  const [isDeleteModalOpened, setisDeleteModalOpened] = useState(false)

  const {
    groups,
    loading: loadingGroups,
    error: errorGroups,
  } = useEditableGroups()

  const [iconHistoryMajorUpdateSection, seticonHistoryMajorUpdateSection] =
    useState('expand_more')
  const handleChangeIconHistoryMajorSection = () => {
    if (iconHistoryMajorUpdateSection === 'expand_more')
      seticonHistoryMajorUpdateSection(() => `expand_less`)
    else {
      seticonHistoryMajorUpdateSection(() => `expand_more`)
    }
  }
  React.useEffect(() => {
    if (!isTagsDeactivated) {
      setisTaggingSelectorOpened(() => true)
    }
  }, [isTagsDeactivated])

  const handleChangeIconTagSection = () => {
    if (iconTaggingSection === 'expand_more')
      seticonTaggingSection(() => `expand_less`)
    else {
      seticonTaggingSection(() => `expand_more`)
    }
  }
  const handleChangeIconRelatedNodesSection = () => {
    if (iconRelatedNodeSection === 'expand_more')
      seticonRelatedNodeSection(() => `expand_less`)
    else {
      seticonRelatedNodeSection(() => `expand_more`)
    }
  }
  const handleChangeIconRelatedSSSection = () => {
    if (iconRelatedSSSection === 'expand_more')
      seticonRelatedSSSection(() => `expand_less`)
    else {
      seticonRelatedSSSection(() => `expand_more`)
    }
  }
  const handleChangeiconDevPathSection = () => {
    if (iconDevPath === 'expand_more') seticonDevPath(() => `expand_less`)
    else {
      seticonDevPath(() => `expand_more`)
    }
  }
  const handleChangeiconActorsSection = () => {
    if (iconActors === 'expand_more') seticonActors(() => `expand_less`)
    else {
      seticonActors(() => `expand_more`)
    }
  }

  const [iconInstructions, seticonInstructions] = useState(
    !!scenarioSet?.instructions?.instructions?.length ||
      !!scenarioSet?.instructions?.fieldInstructions?.length ||
      !!scenarioSet?.instructions?.writingStyles?.length ||
      !!scenarioSet?.instructions?.perspectives?.length ||
      !!scenarioSet?.instructions?.numberOfParagraphs?.length ||
      !!scenarioSet?.instructions?.lengthNarrative?.length
      ? 'expand_more'
      : 'expand_less',
  )
  const handleChangeiconInstructions = () => {
    if (iconInstructions === 'expand_more')
      seticonInstructions(() => `expand_less`)
    else {
      seticonInstructions(() => `expand_more`)
    }
  }

  const handleChangeiconVerbalDrivers = () => {
    if (iconVerbalDrivers === 'expand_more')
      seticonVerbalDrivers(() => `expand_less`)
    else {
      seticonVerbalDrivers(() => `expand_more`)
    }
  }

  const handleChangeiconNarrativeSection = () => {
    if (iconNarrative === 'expand_more') seticonNarrative(() => `expand_less`)
    else {
      seticonNarrative(() => `expand_more`)
    }
  }
  const handleChangeiconScenarioNarrativeSection = () => {
    if (iconScenarioNarrative === 'expand_more')
      seticonScenarioNarrative(() => `expand_less`)
    else {
      seticonScenarioNarrative(() => `expand_more`)
    }
  }
  const handleChangeIconTitleAndSummarySection = () => {
    if (iconTitleAndSummary === 'expand_more')
      seticonTitleAndSummary(() => `expand_less`)
    else {
      seticonTitleAndSummary(() => `expand_more`)
    }
  }

  const loading = loadingGroups
  const error = errorGroups

  if (loading) {
    return <div className="py-5 text-center">Loading...</div>
  }

  if (error) {
    return <div className="py-5 text-center text-danger">{error.message}</div>
  }

  const removeSelector = (selector1, selector2) => {
    const el = document.querySelector(selector1)
    el.classList.remove(selector2)
  }

  const addSelector = (selector1, selector2) => {
    const el = document.querySelector(selector1)
    el.classList.add(selector2)
  }

  const toogleTaggingSelectorModal = () => {
    setisTaggingSelectorOpened(() => !isTaggingSelectorOpened)
  }
  const toogleTaggingSelectorModalToClose = () => {
    setisTaggingSelectorOpened(() => false)
  }
  const onRemove = (values) => {
    scenarioAPIs.deleteScenarioCard({
      gid: gid,
      scenarioId: values?.id || scenario?.id,
    })
  }
  const onReview = (values) => {
    const temp =
      !!values?.developmentPath?.length &&
      values?.developmentPath?.sort((a, b) => a?.year - b?.year)
    dispatch({
      type: ACTIONS.SCENARIO,
      payload: {
        ...values,
        time_range: {
          min: !!temp?.length && temp?.length > 0 ? temp[0]?.year : 2023,
          max: !!temp?.length ? temp[Number(temp?.length) - 1]?.year : 2023,
        },
      },
    })
    onOpenReview()
  }
  const onCloseReview = () => {
    setisReviewModalOpened(() => false)
  }
  const onOpenReview = () => {
    setisReviewModalOpened(() => true)
  }
  const handleCloseDeleteConfirmation = () => {
    setisDeleteModalOpened(false)
  }

  const handleChangeIconHistorySection = () => {
    if (iconHistorySection === 'expand_more')
      seticonHistorySection(() => `expand_less`)
    else {
      seticonHistorySection(() => `expand_more`)
    }
  }

  const onCloseEditingHistory = () => {
    const dataNew = [...historyDataState]
    const dataOld = [...historyData]

    const dataOldWithIndex = dataOld[currentIndexEditingHistory]
    dataNew[currentIndexEditingHistory] = dataOldWithIndex
    sethistoryDataState(() => [...dataNew])
    setisEditHistoryModalOpened(false)
  }

  const descriptionEdtingHistoryHandler = (event) => {
    const value = event.target.value

    const temp = [...historyDataState]
    const temp3 = { ...temp[currentIndexEditingHistory] }

    temp3['description'] = value
    temp[currentIndexEditingHistory] = { ...temp3 }
    sethistoryDataState(() => [...temp])
  }

  const userNameEdtingHistoryHandler = (event) => {
    const value = event.target.value

    const temp = [...historyDataState]
    const temp3 = { ...temp[currentIndexEditingHistory] }

    temp3['editorName'] = value
    temp[currentIndexEditingHistory] = { ...temp3 }
    sethistoryDataState(() => [...temp])
  }

  const userNameEdtingHistorySanitize = (event) => {
    const value = stripAllHtml(event.target.value);

    const temp = [...historyDataState];
    const temp3 = { ...temp[currentIndexEditingHistory] };

    temp3["editorName"] = value;
    temp[currentIndexEditingHistory] = { ...temp3 };
    sethistoryDataState(() => [...temp]);
  };

  const descriptionEdtingHistorySanitize = (event) => {
    const value = stripAllHtml(event.target.value);

    const temp = [...historyDataState];
    const temp3 = { ...temp[currentIndexEditingHistory] };

    temp3["description"] = value;
    temp[currentIndexEditingHistory] = { ...temp3 };
    sethistoryDataState(() => [...temp]);
  };

  return (
    <>
      {!!isDeleteModalOpened && (
        <DeleteConfirmationModal
          handleCloseDeleteConfirmation={handleCloseDeleteConfirmation}
          deleteModalOpenedHandler={async () => {
            setisDeleteModalOpened(false)
            const closeCardBtn = document.querySelector(
              '#block-fp-content--2 > div.side-modal.side-modal-left > button',
            )
            closeCardBtn?.click()
            onRemove()
            onCancel()

            // dispatch event to scenario manager to update the list
            const scenarioCardChangedFromSessionStorage =
              !sessionStorage.getItem('scenarioCardChanged')
                ? 0
                : Number(sessionStorage.getItem('scenarioCardChanged'))

            sessionStorage.setItem(
              'scenarioCardChanged',
              Number(scenarioCardChangedFromSessionStorage) + 1,
            )
            window.dispatchEvent(new Event('storage'))
            // window.location.reload()
          }}
          isDeleteModalOpened={isDeleteModalOpened}
        />
      )}
      {!!isReviewModalOpened && (
        <InformationModal
          historyDataState={historyDataState}
          relatedPhenomena={relatedPhenomenaState}
          relatedScenarios={relatedScenariosState}
          gid={gid}
          data={data}
          InfoModalClose={onCloseReview}
          isReviewModalOpened={isReviewModalOpened}
        />
      )}
      <WarningEditModal
        InfoModalHeader={'Warning!'}
        InfoModalDescription1={'Please note,'}
        InfoModalDescription2={
          'If you opened this scenario card for editing after that moment, the changes made by the other editor are not included in this version. If you save now, their changes will be washed out.'
        }
        InfoModalDescription5={'Please consider the following points:'}
        InfoModalDescription5Sub1={
          'Contact the previous editor to synchronize your changes'
        }
        InfoModalDescription5Sub2={
          'Copy the changes you have made (copy-paste to an external document), close the current scenario card, and reopen the latest version for editing'
        }
        InfoModalDescription5Sub3={
          'We recommend that only one person edits at a time'
        }
        InfoModalDescription3={`that this scenario was edited by ${lastEdited} at
        at ${lastEditedTime}
        .`}
        InfoModalDescription4={'Are you sure you want to Save?'}
        InfoModalOpen={warningEditedWithin30Mins}
        InfoModalClose={() => setWarningEditedWithin30Mins(false)}
        openingFieldEditingModalHandler={() => {
          startingOverWriteScenario()
          setWarningEditedWithin30Mins(false)
        }}
        NameOKBtn="YES"
      />
      <Formik
        initialValues={{
          ...scenario,
          image: scenario?.media?.image,
          relatedPhenomena: relatedPhenomenaState || [],
          history: scenario?.history,
          actors: scenario?.actors,
          verbalDrivers: scenario?.verbalDrivers,
          relatedScenarios: relatedScenariosState,
          language: language,
          majorUpdate: '',
        }}
        validate={(values) => {
          const errors = {}

          if (!values?.title) {
            errors.title =
              'Please insert a title for this scenario before you proceed'
          }

          return errors
        }}
        onSubmit={async (values, { setSubmitting }, errors) => {
          const checkUserEditedRes =
            Number(gid) !== 0
              ? await scenarioAPIs.checkUserEdited(
                  gid,
                  values?.scenarioSetId || null,
                  values?.drivers,
                  // gid !== 0
                  //   ? values?.drivers
                  //   : !!values?.verbalDrivers?.length
                  //   ? values?.verbalDrivers?.length > 1
                  //     ? values?.verbalDrivers
                  //     : values?.verbalDrivers?.length === 1
                  //     ? [values?.verbalDrivers[0], values?.verbalDrivers[0]]
                  //     : ['min', 'max']
                  //   : ['min', 'max'],
                )
              : false
          if (
            !!checkUserEditedRes &&
            !!checkUserEditedRes?.data?.ChangedWithin30Mins &&
            Number(lastEditorId) !==
              Number(checkUserEditedRes?.data?.updated_by)
          ) {
            setFieldsValuesChanged(() => values)
            seteditorData(() => checkUserEditedRes)
            setWarningEditedWithin30Mins(true)
          } else {
            if (!!values.title?.length || values.title !== '') {
              try {
                const phenomenonInput = {
                  ...values,
                }
                const storedImg =
                  !!fileImg && (await handleImageUploadIfNeeded(fileImg, gid))
                // let resp = null

                const devPathsTemp = [...devPaths]?.map((dp) => {
                  return { description: dp?.description, year: dp?.year }
                })

                await saveScenario({
                  ...values,
                  isMainActorsDeactivated,
                  isRelatedScenariosDeactivated,
                  isTagsDeactivated,
                  developmentPath: devPathsTemp,
                  media: {
                    video: phenomenonInput?.video,
                    image: !!storedImg
                      ? `${storedImg}`
                      : phenomenonInput?.imageUrl || '',
                    text: phenomenonInput?.videoText,
                  },
                })
                if (!!values?.id) {
                  const scenarioCardChangedFromSessionStorage =
                    !sessionStorage.getItem('scenarioCardChanged')
                      ? 0
                      : Number(sessionStorage.getItem('scenarioCardChanged'))

                  sessionStorage.setItem(
                    'scenarioCardChanged',
                    Number(scenarioCardChangedFromSessionStorage) + 1,
                  )
                  window.dispatchEvent(new Event('storage'))
                }
              } catch (error) {
                console.error(error.message)
              }
            }
          }
        }}>
        {({
          values,
          setFieldValue,
          setFieldTouched,
          touched,
          errors,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          isValid,
        }) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            //setGroupId(values.group)
          }, [values.group])

          const toggleRelatedPhenomenon = (phenomenon) => {
            const exists = values.relatedPhenomena.find(
              (relatedPhenomenon) => phenomenon.id === relatedPhenomenon.id,
            )

            setFieldValue(
              'relatedPhenomena',
              exists
                ? values.relatedPhenomena.filter(
                    (relatedPhenomenon) =>
                      phenomenon.id !== relatedPhenomenon.id,
                  )
                : values.relatedPhenomena.concat([phenomenon]),
            )
            setrelatedPhenomenaState(() =>
              exists
                ? values.relatedPhenomena.filter(
                    (relatedPhenomenon) =>
                      phenomenon.id !== relatedPhenomenon.id,
                  )
                : values.relatedPhenomena.concat([phenomenon]),
            )
          }
          const toggleRelatedScenarios = (phenomenon) => {
            const exists = values.relatedScenarios.find(
              (relatedScenarios) => phenomenon.id === relatedScenarios.id,
            )
            setFieldValue(
              'relatedScenarios',
              exists
                ? values.relatedScenarios.filter(
                    (relatedScenarios) => phenomenon.id !== relatedScenarios.id,
                  )
                : values.relatedScenarios.concat([phenomenon]),
            )
            setrelatedScenariosState(() =>
              exists
                ? values.relatedScenarios.filter(
                    (relatedScenarios) => phenomenon.id !== relatedScenarios.id,
                  )
                : values.relatedScenarios.concat([phenomenon]),
            )
          }

          const setRelatedPhenomenaSort = ({ newIndex, oldIndex }) => {
            const ordered = values.relatedPhenomena.slice()
            ordered.splice(newIndex, 0, ordered.splice(oldIndex, 1)[0])
            setFieldValue('relatedPhenomena', ordered)
          }
          const setRelatedScenariosSort = ({ newIndex, oldIndex }) => {
            const ordered = values.relatedScenarios.slice()
            ordered.splice(newIndex, 0, ordered.splice(oldIndex, 1)[0])
            setFieldValue('relatedScenarios', ordered)
          }
          const handleImageSelect = (e, file) => {
            const fileName = file || e.target.files[0]
            const reader = new FileReader()

            reader.onload = () => {
              let img = new Image()
              img.src = URL.createObjectURL(fileName)

              img.onload = () => {
                setFieldValue('image', reader.result)

                setFieldValue('imageFile', fileName)
              }
            }

            reader.readAsDataURL(fileName)
            setfileImg(fileName)
          }

          const group = groups.find((group) => group.id === values.group)
          if (values.uuid && !group) {
            return (
              <div className="text-center text-danger py-5">
                You do not have the permission to{' '}
                {values.uuid ? 'edit this' : 'add a'} phenomenon.
              </div>
            )
          }

          const isDev = isDevEnv()
          
          return (
            <div>
              <div
                className="modal-form-sections"
                style={{ position: 'relative' }}>
                <div
                  className="modal-form-section modal-form-header"
                  style={{
                    paddingBottom: '30px',
                  }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingBottom: '12px',
                    }}>
                    <DriversImg src={icon} />
                    <h2 style={{ marginLeft: '24px' }}>
                      Create/edit scenario card
                    </h2>

                    <InformationIcon
                      style={{
                        margin: 0,
                        marginLeft: '18px',
                      }}
                      background={false}
                      onMouseEnter={onHoverStep1Icon}
                      onMouseLeave={onLeaveStep1Icon}
                      onClick={openStep1InformationModalHandle}
                    />

                    <InformationModal2
                      InfoModalUL="Please read the given instructions for filling in the scenario card. For more information about scenario writing, you can read the article below"
                      // InfoModalUL2="Narrative"
                      // InfoModalUL3="Development path"
                      // //  InfoModalUL4="Tags"
                      // InfoModalDescription="Write a brief summary containing the main points of the scenario."
                      // InfoModalDescription2="It is advisable to write the summary last, once the narrative and development paths are
                      // ready."
                      // // InfoModalDescriptionSub3="What the world or context is like in the scenario"
                      // // InfoModalDescriptionSub2="How things could roughly play out within the given situation"
                      // // InfoModalDescriptionSub1="How it will impact your organisation or what actions it should take."
                      // // InfoModalDescription3="If possible, start writing the Scenario Narrative first."
                      // // InfoModalDescriptionC="The scenario should be written to reflect a world where the developments of the axes reach the given point (minimum/maximum) and how their developments interact with one another"
                      // // InfoModalDescriptionD="Remember to address any perspectives given in the instructions"
                      // InfoModalDescriptionA="Write here the scenario narrative."
                      // InfoModalDescriptionB="The narrative should be a concise, logical and coherent story of how the world looks like
                      // from key uncertainties’ point of view."
                      // InfoModalDescriptionC="The scenario should be written to reflect a world where the developments of the axes reach
                      // the given point (minimum/maximum) and how their developments interact with one
                      // another."
                      // InfoModalDescriptionD="Remember to follow the writing style, the given length, and address any perspectives given
                      // in the instructions."
                      // InfoModalDescriptionE="It is recommended to discuss the different perspectives in separate paragraphs and in logical order."
                      // // InfoModalDescriptionF="Select the appropriate year and enter event descriptions in the designated field."
                      // // InfoModalDescription2E=''
                      // InfoModalDescription2A="Development path typically consists of 3-5 events from present to the scenario’s future."
                      // InfoModalDescription2B="Choose the appropriate year and write the event description in the field."
                      // InfoModalDescription2C="Click “+Add” for more events."
                      // InfoModalDescription2D="Forming the path helps in identifying what needs to happen for the scenario to be realized."
                      // InfoModalDescription2E="The path can act as a set of indicators showing whether the scenario will take place or not."
                      // InfoModalDescription2F="If there are several events for one year, it is recommended to separate them to different event modules."
                      // InfoModalUL="A short and distinctive name to your scenario project"
                      // InfoModalDescription4="Only the editors and coordinators can edit the scenario set"
                      InfoModalHeader={'Write and edit the scenarios'}
                      // InfoModalNote={
                      //   'A short and distinctive name to your scenario project'
                      // }
                      InfoModalOpen={step1InformationModal}
                      InfoModalClose={closeStep1InformationModalHandle}
                      LearnMoreBtn={'How to write the scenario texts?'}
                      // GuideBtn={requestTranslation('GuideVotingBtn')}
                      LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                      // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                    />
                  </div>
                  {/* <p style={{ marginLeft: '69px', fontSize: '14px' }}>
                    {`You are working on ${
                      gid !== 0 ? 'axes_of_uncertainty' : 'FP-Scenario'
                    }`}
                  </p> */}
                  <p
                    style={{
                      fontWeight: 500,
                      marginLeft: '69px',
                      fontSize: '14px',
                    }}>
                    {`The related scenarios should be comparable. Hence, fill in only the parts, and all the parts, that are decided by your team / facilitator.`}
                  </p>
                  {/* <p style={{ fontWeight: 500, marginLeft: '69px' }}>
                    Write your scenario narrative here and add additional
                    information also
                  </p> */}
                </div>
                <div
                  className="modal-form-section"
                  style={{ display: 'none' }}></div>
                <div className="modal-form-section">
                  <div className="form-group">
                    {/* <h4
                      style={{
                        fontFamily: 'L10',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: '18px',
                        lineHeight: '18px',
                        letterSpacing: '0.0714286px',
                      }}>
                      Instructions
                    </h4> */}
                    <>
                      <Dropdown
                        className="dropdown-toggle d-flex align-items-center justify-content-between"
                        type="button"
                        // data-toggle="collapse"
                        data-target="#collapseInstructions"
                        aria-expanded={
                          iconInstructions === 'expand_more' ? 'true' : 'false'
                        }
                        onClick={handleChangeiconInstructions}
                        style={{ cursor: 'pointer' }}>
                        <h3
                          style={{
                            fontFamily: 'L10',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '20px',
                            lineHeight: '18px',
                            letterSpacing: '0.0714286px',
                          }}>
                          Instructions
                        </h3>
                        <div>
                          <i className="material-icons">{iconInstructions}</i>
                        </div>
                      </Dropdown>
                      <div
                        id="collapseInstructions"
                        className={`${
                          iconInstructions === 'expand_more'
                            ? ' collapse show'
                            : ' collapse'
                        }`}>
                        <div className="form-group">
                          {/* <h4>Development Path</h4> */}
                          <ul
                            className="d-flex flex-column"
                            style={{
                              fontfamily: 'L10',
                              fontStyle: 'normal',
                              fontweight: 500,
                              fontSize: '14px',
                              lineHeight: '20px',
                              listStylePosition: 'outside',
                            }}>
                            {!!scenarioSet?.instructions?.fieldInstructions
                              ?.length && (
                              <li
                                style={{
                                  marginBottom: '6px',
                                }}>
                                Fill in the following fields:{' '}
                                <strong>
                                  {scenarioSet?.instructions?.fieldInstructions}
                                </strong>
                              </li>
                            )}
                            {!!scenarioSet?.instructions?.lengthNarrative
                              ?.length && (
                              <li
                                style={{
                                  marginBottom: '6px',
                                }}>
                                Length of the narrative:{' '}
                                <strong>
                                  {scenarioSet?.instructions?.lengthNarrative}
                                </strong>
                              </li>
                            )}
                            {!!scenarioSet?.instructions?.numberOfParagraphs
                              ?.length && (
                              <li
                                style={{
                                  marginBottom: '6px',
                                }}>
                                Number of the paragraphs:{' '}
                                <strong>
                                  {
                                    scenarioSet?.instructions
                                      ?.numberOfParagraphs
                                  }
                                </strong>
                              </li>
                            )}
                            {!!scenarioSet?.instructions?.perspectives
                              ?.length && (
                              <li
                                style={{
                                  marginBottom: '6px',
                                }}>
                                Perspectives:{' '}
                                <strong>
                                  {scenarioSet?.instructions?.perspectives}
                                </strong>
                              </li>
                            )}
                            {!!scenarioSet?.instructions?.writingStyles
                              ?.length && (
                              <li
                                style={{
                                  marginBottom: '6px',
                                }}>
                                Writings style:{' '}
                                <strong>
                                  {!!scenarioSet?.instructions?.writingStyles
                                    ?.length &&
                                    scenarioSet?.instructions?.writingStyles?.map(
                                      (wr) => {
                                        if (
                                          wr ===
                                          scenarioSet?.instructions
                                            ?.writingStyles[
                                            scenarioSet?.instructions
                                              ?.writingStyles?.length - 1
                                          ]
                                        ) {
                                          if (!!wr?.includes('harry-marked/')) {
                                            return wr?.substring(13)
                                          } else return wr
                                        } else {
                                          if (!!wr?.includes('harry-marked/')) {
                                            return wr?.substring(13) + ' - '
                                          }
                                          return wr + ' - '
                                        }
                                      },
                                    )}
                                </strong>
                              </li>
                            )}
                            {!!scenarioSet?.instructions?.fieldInstructions
                              ?.length && (
                              <li
                                style={{
                                  marginBottom: '6px',
                                }}>
                                Suggested editors:{' '}
                                <strong>
                                  {scenarioSet?.instructions?.fieldInstructions}
                                </strong>
                              </li>
                            )}
                            {!!scenarioSet?.instructions?.instructions
                              ?.length && (
                              <li>
                                More info:{' '}
                                <strong>
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html:
                                        scenarioSet?.instructions?.instructions,
                                    }}></span>
                                </strong>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                    </>
                  </div>
                </div>
                <div className="modal-form-section">
                  <div className="form-group">
                    {Number(gid) !== 0 && (
                      <div
                        style={{
                          display: 'flex',
                          marginBottom: '14.4px',
                        }}>
                        <h3
                          style={{
                            fontFamily: 'L10',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '20px',
                            lineHeight: '18px',
                            letterSpacing: '0.0714286px',
                            margin: 0,
                          }}>
                          Drivers used in this scenario
                        </h3>
                        <InformationIcon
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                          }}
                          background={false}
                          onMouseEnter={onHoverStep1Icon}
                          onMouseLeave={onLeaveStep1Icon}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setdriversEditorInfo(true)
                          }}
                        />
                        <InformationModal2
                          InfoModalUL={`Here, you'll see the chosen drivers with their designated values. For example, the first driver may have a minimum value and the other a maximum value. This will serve as the key guideline for building the scenario. You should consider that specific situation when formulating your general perspective on that scenario. Each of the three other scenarios has different driver value combinations in their scenarios. For example, in a scenario where the X axis "Increase in foreign immigration" has a minimum value and the Y axis "Rise of the number of US residents who desire to own property in San Francisco" has a maximum value, the narrative could start with: “The level of foreign immigration in San Francisco remains the same as the present, while the number of US residents who desire to own property in San Francisco reaches a new record high, or becomes unimaginably high.”`}
                          // InfoModalDescription2="Instruct the division of work: who writes which scenario."
                          // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
                          // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
                          // InfoModalDescription5="For development paths, define how many events are need in each scenario."
                          // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                          // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                          // how many events are need in each scenario."
                          // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                          // style should be followed?"
                          InfoModalHeader={'Drivers used in this scenario'}
                          // InfoModalNote={
                          //   'A short and distinctive name to your scenario project'
                          // }
                          InfoModalOpen={driversEditorInfo}
                          InfoModalClose={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setdriversEditorInfo(false)
                          }}
                          // LearnMoreBtn={'How to write the scenario texts?'}
                          // GuideBtn={requestTranslation('GuideVotingBtn')}
                          // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                          // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                        />
                      </div>
                    )}
                    <div>
                      <>
                        {scenarioSet?.type !== 'futures_table' ? (
                          <>
                            {Number(gid) === 0 && (
                              <>
                                <Dropdown
                                  className="dropdown-toggle d-flex align-items-center justify-content-between"
                                  type="button"
                                  // data-toggle="collapse"
                                  data-target="#collapseVerbalDrivers"
                                  aria-expanded={
                                    iconVerbalDrivers === 'expand_more'
                                      ? 'true'
                                      : 'false'
                                  }
                                  onClick={handleChangeiconVerbalDrivers}
                                  style={{ cursor: 'pointer' }}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      marginBottom: '14.4px',
                                    }}>
                                    <h3
                                      style={{
                                        fontFamily: 'L10',
                                        fontStyle: 'normal',
                                        fontWeight: 700,
                                        fontSize: '20px',
                                        lineHeight: '18px',
                                        letterSpacing: '0.0714286px',
                                        margin: 0,
                                      }}>
                                      Drivers used in this scenario
                                    </h3>
                                    <InformationIcon
                                      style={{
                                        marginTop: 0,
                                        marginBottom: 0,
                                      }}
                                      background={false}
                                      onMouseEnter={onHoverStep1Icon}
                                      onMouseLeave={onLeaveStep1Icon}
                                      onClick={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        setdriversEditorInfo(true)
                                      }}
                                    />
                                    <InformationModal2
                                      InfoModalUL={`Here, you'll see the chosen drivers with their designated values. For example, the first driver may have a minimum value and the other a maximum value. This will serve as the key guideline for building the scenario. You should consider that specific situation when formulating your general perspective on that scenario. Each of the three other scenarios has different driver value combinations in their scenarios. For example, in a scenario where the X axis "Increase in foreign immigration" has a minimum value and the Y axis "Rise of the number of US residents who desire to own property in San Francisco" has a maximum value, the narrative could start with: “The level of foreign immigration in San Francisco remains the same as the present, while the number of US residents who desire to own property in San Francisco reaches a new record high, or becomes unimaginably high.”`}
                                      // InfoModalDescription2="Instruct the division of work: who writes which scenario."
                                      // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
                                      // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
                                      // InfoModalDescription5="For development paths, define how many events are need in each scenario."
                                      // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                                      // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                                      // how many events are need in each scenario."
                                      // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                                      // style should be followed?"
                                      InfoModalHeader={
                                        'Drivers used in this scenario'
                                      }
                                      // InfoModalNote={
                                      //   'A short and distinctive name to your scenario project'
                                      // }
                                      InfoModalOpen={driversEditorInfo}
                                      InfoModalClose={(e) => {
                                        e.preventDefault()
                                        e.stopPropagation()
                                        setdriversEditorInfo(false)
                                      }}
                                      // LearnMoreBtn={
                                      //   'How to write the scenario texts?'
                                      // }
                                      // GuideBtn={requestTranslation('GuideVotingBtn')}
                                      // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                                      // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                                    />
                                  </div>
                                  <div>
                                    <i className="material-icons">
                                      {iconVerbalDrivers}
                                    </i>
                                  </div>
                                </Dropdown>
                                <div
                                  id="collapseVerbalDrivers"
                                  className={`${
                                    iconVerbalDrivers === 'expand_more'
                                      ? ' collapse show'
                                      : ' collapse'
                                  }`}>
                                  <div className="form-group">
                                    {/* <h4>Development Path</h4> */}
                                    <div
                                      className="d-flex flex-column"
                                      style={{
                                        fontfamily: 'L10',
                                        fontStyle: 'normal',
                                        fontweight: 500,
                                        fontSize: '14px',
                                        lineHeight: '20px',
                                      }}>
                                      <VerbalDrivers
                                        value={values?.verbalDrivers}
                                        // onChange={(value) => {
                                        //   values.developmentPath = value
                                        // }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            {gid !== 0 && (
                              <>
                                <li
                                  style={{
                                    fontFamily: 'L10',
                                    fontStyle: 'normal',
                                    // fontWeight: 500,
                                    fontSize: '14px',
                                    lineHeight: '24px',
                                    letterSpacing: '0.0642857px',
                                  }}>
                                  {!!scenarioSet?.drivers?.length
                                    ? scenarioSet?.drivers[1]?.title
                                    : ''}{' '}
                                  {' : '}{' '}
                                  <span
                                  // style={{ fontWeight: 700 }}
                                  >
                                    {!!values?.drivers?.length
                                      ? Number(values?.drivers[1]) === -1
                                        ? 'Min'
                                        : 'Max'
                                      : ''}
                                  </span>
                                </li>
                                <li
                                  style={{
                                    fontFamily: 'L10',
                                    fontStyle: 'normal',
                                    // fontWeight: 500,
                                    fontSize: '14px',
                                    lineHeight: '24px',
                                    letterSpacing: '0.0642857px',
                                  }}>
                                  {!!scenarioSet?.drivers?.length
                                    ? scenarioSet?.drivers[0]?.title
                                    : ''}{' '}
                                  {' : '}{' '}
                                  <span
                                  // style={{ fontWeight: 700 }}
                                  >
                                    {!!values?.drivers?.length
                                      ? Number(values?.drivers[0]) === -1
                                        ? 'Min'
                                        : 'Max'
                                      : ''}
                                  </span>
                                </li>
                              </>
                            )}
                          </>
                        ) : (
                          <>
                            {driversFuturesTables?.matrixCells?.map(
                              (info, index) => (
                                <div style={{ fontSize: '13px' }}>
                                  <li key={index}>
                                    {info?.driver}
                                    {': '}
                                    <strong>{info?.content}</strong>
                                    {/* Content from Futures table:{' '}
                                    <strong>{info?.content}</strong>
                                    {' in the '}
                                    <strong>{info?.driver}</strong>
                                    {' that is marked with '}
                                    <strong>{info?.color}</strong>
                                    {' on '}
                                    <strong>{info.futureState}</strong> */}
                                  </li>
                                </div>
                              ),
                            )}
                          </>
                        )}
                      </>
                    </div>
                  </div>
                </div>

                <div className="modal-form-section">
                  <div className="col-6">
                    <div className="form-group">
                      {/* <h3>{requestTranslation('language')}</h3> */}
                      <h3>Language</h3>

                      <Select
                        name="language"
                        className="fp-radar-select fp-radar-select--no-margin w-100"
                        value={values.language}
                        onChange={({ value }) => {
                          setFieldValue('language', value)
                          setFieldValue('relatedPhenomena', [])
                        }}
                        options={getAvailableLanguages()}
                        searchable={false}
                        clearable={false}
                      />
                      {touched.language && errors.language && (
                        <div className="description text-danger">
                          {errors.language}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="modal-form-section">
                  <Dropdown
                    className="dropdown-toggle d-flex align-items-center justify-content-between"
                    type="button"
                    // data-toggle="collapse"
                    data-target="#collapsemedia"
                    aria-expanded={
                      iconTitleAndSummary === 'expand_more' ? 'true' : 'false'
                    }
                    onClick={handleChangeIconTitleAndSummarySection}
                    style={{ cursor: 'pointer' }}>
                    <h3
                      className="mb-0"
                      style={{
                        fontFamily: 'L10',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: '20px',
                        lineHeight: '31px',
                        letterSpacing: '0.0928571px',
                      }}>
                      Title and summary
                    </h3>
                    <div>
                      <i className="material-icons">{iconTitleAndSummary}</i>
                    </div>
                  </Dropdown>
                  <div
                    id="collapsemedia"
                    className={`mt-4 ${
                      iconTitleAndSummary === 'expand_more'
                        ? ' collapse show'
                        : ' collapse'
                    }`}
                    style={{ marginTop: '30px !important' }}>
                    <div className="form-group">
                      <div
                        style={{
                          display: 'flex',
                          marginBottom: '14.4px',
                          alignItems: 'center',
                        }}>
                        <h4
                          style={{
                            fontFamily: 'L10',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '16px',
                            lineHeight: '18px',
                            letterSpacing: '0.0714286px',
                            margin: 0,
                          }}>
                          Title
                        </h4>
                        <InformationIcon
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                          }}
                          background={false}
                          onMouseEnter={onHoverStep1Icon}
                          onMouseLeave={onLeaveStep1Icon}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            settitleEditorInfo(true)
                          }}
                        />
                        <InformationModal2
                          InfoModalUL={`Each scenario should be given a descriptive name that highlights and distinguishes its core issue, unique characteristics and the change in it, and also differentiates it from the other scenarios. The title should address either quite directly the situation that the two drives values make (if X is Max and Y is Min then what kind of situation is that? e.g. AI Becomes a True Creative Partner for Humans), or it should refer to the possible outcome of that situation (e.g. Road to economic recession).`}
                          // InfoModalDescription2="Instruct the division of work: who writes which scenario."
                          // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
                          // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
                          // InfoModalDescription5="For development paths, define how many events are need in each scenario."
                          // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                          // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                          // how many events are need in each scenario."
                          // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                          // style should be followed?"
                          InfoModalHeader={'Title'}
                          // InfoModalNote={
                          //   'A short and distinctive name to your scenario project'
                          // }
                          InfoModalOpen={titleEditorInfo}
                          InfoModalClose={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            settitleEditorInfo(false)
                          }}
                          // LearnMoreBtn={'How to write the scenario texts?'}
                          // GuideBtn={requestTranslation('GuideVotingBtn')}
                          // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                          // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                        />
                      </div>
                      <textarea
                        rows="3"
                        id="title"
                        type="text"
                        name="title"
                        value={values?.title || ''}
                        onChange={handleChange}
                        onBlur={(e) => {
                          let event = e
                          event.target.value = stripAllHtml(event.target.value)
                          handleChange(event)
                        }}
                        onPaste={handlePaste}
                        style={{
                          // borderRadius: '25px',
                          borderColor: !!errors?.title
                            ? 'red'
                            : 'rgb(204, 204, 204)',
                          resize: 'none',
                          height: '88px',
                        }}></textarea>
                      {!!errors?.title && (
                        <div
                          style={{
                            color: 'red',
                            fontSize: '12px',
                            fontFamily: 'italic',
                            fontWeight: 500,
                          }}>
                          {`* ${errors?.title}`}
                        </div>
                      )}
                    </div>
                    <div className="form-group">
                      <div
                        style={{
                          display: 'flex',
                          marginBottom: '14.4px',
                          alignItems: 'center',
                        }}>
                        <h4
                          style={{
                            fontFamily: 'L10',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '16px',
                            lineHeight: '18px',
                            letterSpacing: '0.0714286px',
                            margin: 0,
                          }}>
                          Short title
                        </h4>
                        <InformationIcon
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                          }}
                          background={false}
                          onMouseEnter={onHoverStep1Icon}
                          onMouseLeave={onLeaveStep1Icon}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setshortTitleEditorInfo(true)
                          }}
                        />
                        <InformationModal2
                          ismrginTopUL2={1}
                          InfoModalUL={`You can give your scenarios short nicknames.`}
                          InfoModalUL2={`The idea is simple: in many views, longer scenario names take up too much space and attention, so shortened names would keep the views more visually clear. (This same idea is already in use on the radar: a short title appears on the radar screen, then clicking on the content card shows the full title.)`}
                          // InfoModalDescription2="Instruct the division of work: who writes which scenario."
                          // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
                          // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
                          // InfoModalDescription5="For development paths, define how many events are need in each scenario."
                          // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                          // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                          // how many events are need in each scenario."
                          // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                          // style should be followed?"
                          InfoModalHeader={'Short title'}
                          // InfoModalNote={
                          //   'A short and distinctive name to your scenario project'
                          // }
                          InfoModalOpen={shortTitleEditorInfo}
                          InfoModalClose={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setshortTitleEditorInfo(false)
                          }}
                          // LearnMoreBtn={'How to write the scenario texts?'}
                          // GuideBtn={requestTranslation('GuideVotingBtn')}
                          // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                          // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                        />
                      </div>
                      <textarea
                        rows="3"
                        id="short"
                        type="text"
                        name="short"
                        value={values?.short}
                        onChange={handleChange}
                        onBlur={(e) => {
                          let event = e
                          event.target.value = stripAllHtml(event.target.value)
                          handleChange(event)
                        }}
                        onPaste={handlePaste}>
                      </textarea>
                    </div>

                    <div className="form-group" style={{ marginTop: '20px' }}>
                      <div
                        style={{
                          display: 'flex',
                          marginBottom: '14.4px',
                          alignItems: 'center',
                        }}>
                        <h4
                          style={{
                            fontFamily: 'L10',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '16px',
                            lineHeight: '18px',
                            letterSpacing: '0.0714286px',
                            margin: 0,
                          }}>
                          Summary
                        </h4>
                        <InformationIcon
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                          }}
                          background={false}
                          onMouseEnter={onHoverStep1Icon}
                          onMouseLeave={onLeaveStep1Icon}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setsummaryEditorInfo(true)
                          }}
                        />
                        <InformationModal2
                          InfoModalUL={`In the summary-section, you should provide an overview of the key changes in the scenario. It is recommended to write the summary in a single concise paragraph
                          instead of a bullet point list. The summary should address at least these three points; what the world or context looks like in this particular scenario, how things could roughly play out within the given situation, and how it will impact your organisation, or what actions your organisation should take. It might be easiest to write the summary as the last step, after you have filled in the narrative and other parts of the scenario.`}
                          // InfoModalDescription2="Instruct the division of work: who writes which scenario."
                          // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
                          // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
                          // InfoModalDescription5="For development paths, define how many events are need in each scenario."
                          // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                          // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                          // how many events are need in each scenario."
                          // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                          // style should be followed?"
                          InfoModalHeader={'Summary'}
                          // InfoModalNote={
                          //   'A short and distinctive name to your scenario project'
                          // }
                          InfoModalOpen={summaryEditorInfo}
                          InfoModalClose={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setsummaryEditorInfo(false)
                          }}
                          // LearnMoreBtn={'How to write the scenario texts?'}
                          // GuideBtn={requestTranslation('GuideVotingBtn')}
                          // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                          // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                        />
                      </div>
                      <textarea
                        id="summary"
                        className="fp-wysiwyg"
                        toolbar="false"
                        style={{
                          height: '150px',
                          paddingBottom: '42px',
                        }}
                        value={values?.summary || ''}
                        onChange={handleChange}
                        //onChange={(value) => (values.summary = value)}
                        onBlur={(e) => {
                          let event = e
                          event.target.value = stripAllHtml(event.target.value)
                          handleChange(event)
                        }}
                        onPaste={handlePaste}>
                      </textarea>
                    </div>

                    <div className="form-group" style={{ marginTop: '20px' }}>
                      <h4
                        style={{
                          fontFamily: 'L10',
                          fontStyle: 'normal',
                          fontWeight: 700,
                          fontSize: '16px',
                          lineHeight: '18px',
                          letterSpacing: '0.0714286px',
                        }}>
                        Image / Photo{' '}
                      </h4>
                      <SelectImageContainer>
                        {!values?.image && 'No image selected'}
                        {values?.image && (
                          <div
                            className="position-relative w-100"
                            style={{ backgroundColor: 'rgba(0,0,0, 0.1)' }}>
                            <img
                              alt=""
                              className="img-fluid"
                              // src={
                              //   !!isDev
                              //     ? mediaURL + '/' + values?.image
                              //     : values?.image
                              // }
                              src={values?.image}
                            />
                            <RadarImageCloseContainer
                              onClick={() => {
                                setFieldValue('image', null)
                                setFieldValue('imageFile', null)
                                setFieldValue('imageUrl', null)
                              }}>
                              <RadarImageClose className="material-icons">
                                close
                              </RadarImageClose>
                            </RadarImageCloseContainer>
                          </div>
                        )}
                        <SelectImageInputContainer
                          className="btn btn-outline-secondary"
                          style={{ cursor: 'pointer' }}>
                          <SelectImageInputCustom
                            style={{}}
                            type="file"
                            accept="image/*"
                            // className="btn btn-outline-secondary"
                            onChange={handleImageSelect}
                            placeholder={'SELECT'}
                          />
                          <SelectImageButton
                            style={{
                              color: 'unset',
                              border: 'unset',
                              cursor: 'pointer',
                            }}
                            // className="btn btn-sm btn-outline-secondary"
                          >
                            {'SELECT'}
                          </SelectImageButton>
                        </SelectImageInputContainer>
                      </SelectImageContainer>
                      <p className={'description'}>
                        Please use at least a 600 px wide image. Files must be
                        less than 2 MB. Accepted file types: jpg jpeg png gif.
                        Please remember to check that you have the right to
                        publish the image.
                      </p>
                    </div>
                    <div className="form-group">
                      <h4
                        style={{
                          fontFamily: 'L10',
                          fontStyle: 'normal',
                          fontWeight: 700,
                          fontSize: '16px',
                          lineHeight: '18px',
                          letterSpacing: '0.0714286px',
                        }}>
                        Caption
                      </h4>
                      <Input
                        type={'text'}
                        name="videoText"
                        value={values.videoText}
                        onChange={handleChange}
                        onBlur={(e) => {
                          let event = e
                          event.target.value = stripAllHtml(event.target.value)
                          handleChange(event)
                        }}
                        onPaste={handlePaste}
                      />
                      <p
                        className={'description'}
                        style={{
                          color: 'rgb(99, 114, 130)',
                        }}>
                        Remember to show here the source / copyright info.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="modal-form-section">
                  <Dropdown
                    className="dropdown-toggle d-flex align-items-center justify-content-between"
                    type="button"
                    // data-toggle="collapse"
                    data-target="#collapsescenarionarrative"
                    aria-expanded={
                      iconScenarioNarrative === 'expand_more' ? 'true' : 'false'
                    }
                    onClick={handleChangeiconScenarioNarrativeSection}
                    style={{ cursor: 'pointer' }}>
                    <h3
                      className="mb-0"
                      style={{
                        fontFamily: 'L10',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: '20px',
                        lineHeight: '31px',
                        letterSpacing: '0.0928571px',
                      }}>
                      Scenario narrative
                    </h3>
                    <div>
                      <i className="material-icons">{iconScenarioNarrative}</i>
                    </div>
                  </Dropdown>
                  <div
                    id="collapsescenarionarrative"
                    className={`mt-4 ${
                      iconScenarioNarrative === 'expand_more'
                        ? ' collapse show'
                        : ' collapse'
                    }`}
                    style={{ marginTop: '30px !important' }}>
                    {/* <div
                      className="form-group"
                      style={{ marginBottom: '1.5rem !important' }}>
                      <h4
                        style={{
                          fontFamily: 'L10',
                          fontStyle: 'normal',
                          fontWeight: 700,
                          fontSize: '18px',
                          lineHeight: '18px',
                          letterSpacing: '0.0714286px',
                        }}>
                        Perspectives and instructions
                      </h4>
                      <div>
                        {typeof scenarioSet?.instructions === 'string' &&
                          (!scenarioSet?.instructions?.length ||
                          scenarioSet?.instructions === '' ? (
                            <span> {scenarioSet?.instructions}</span>
                          ) : (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: scenarioSet?.instructions,
                              }}></span>
                          ))}
                      </div>
                    </div> */}
                    <Dropdown
                      className="dropdown-toggle d-flex align-items-center justify-content-between"
                      type="button"
                      // data-toggle="collapse"
                      data-target="#collapsenarrative"
                      aria-expanded={
                        iconNarrative === 'expand_more' ? 'true' : 'false'
                      }
                      onClick={handleChangeiconNarrativeSection}
                      style={{ cursor: 'pointer' }}>
                      <div
                        style={{
                          display: 'flex',
                          marginBottom: '14.4px',
                          alignItems: 'center',
                        }}>
                        <h4
                          style={{
                            fontFamily: 'L10',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '16px',
                            lineHeight: '18px',
                            letterSpacing: '0.0714286px',
                            marginBottom: '0.8rem',
                            margin: 0,
                          }}>
                          Narrative
                        </h4>
                        <InformationIcon
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                          }}
                          background={false}
                          onMouseEnter={onHoverStep1Icon}
                          onMouseLeave={onLeaveStep1Icon}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setnarrativeEditorInfo(true)
                          }}
                        />
                        <InformationModal2
                          InfoModalUL={`Here, you can elaborate more on various perspectives on how the scenario could play out, detailing the business opportunities, customer personas, behaviours of relevant institutions and competitors, and other threats that might endanger your organisation in the given scenario.`}
                          InfoModalUL2="The ‘Scenario narrative’ section consists of multiple paragraphs that collectively provide a more comprehensive analysis of your research question. Each paragraph should focus on a different perspective related to the topic. Follow the given instructions about the perspectives, number of paragraphs needed in your scenarios, and the optimal length of the narrative. When writing a narrative, follow the 5C1P (Clear, Concise, Coherent, Concrete, Complete, and Plausible) principles."
                          // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
                          // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
                          // InfoModalDescription5="For development paths, define how many events are need in each scenario."
                          // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                          // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                          // how many events are need in each scenario."
                          // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                          // style should be followed?"
                          InfoModalHeader={'Narrative used in this scenario'}
                          // InfoModalNote={
                          //   'A short and distinctive name to your scenario project'
                          // }
                          InfoModalOpen={narrativeEditorInfo}
                          InfoModalClose={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setnarrativeEditorInfo(false)
                          }}
                          // LearnMoreBtn={'How to write the scenario texts?'}
                          // GuideBtn={requestTranslation('GuideVotingBtn')}
                          // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                          // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                        />
                      </div>
                      <div>
                        <i className="material-icons">{iconNarrative}</i>
                      </div>
                    </Dropdown>
                    <div
                      id="collapsenarrative"
                      className={` ${
                        iconNarrative === 'expand_more'
                          ? ' collapse show'
                          : ' collapse'
                      }`}
                      style={{ marginBottom: '1.5rem' }}>
                      <div className="form-group" style={{ marginBottom: 0 }}>
                        <ReactQuill
                          preserveWhitespace={true}
                          id="body"
                          className="fp-wysiwyg"
                          style={{
                            height: '342px',
                            whiteSpace: 'pre',
                            // paddingBottom: '42px',
                          }}
                          modules={quillModules}
                          formats={quillFormats}
                          value={values?.narrative || values?.body || ''}
                          onChange={(value) => (values.narrative = value)}
                          onBlur={(range, role, field) => {
                            values.narrative = sanitizeWysiwyg(field.getHTML());
                          }}
                          onPaste={handlePaste}
                        />
                      </div>
                    </div>

                    <Dropdown
                      className="dropdown-toggle d-flex align-items-center justify-content-between"
                      type="button"
                      // data-toggle="collapse"
                      data-target="#collapsedevpaths"
                      aria-expanded={
                        iconDevPath === 'expand_more' ? 'true' : 'false'
                      }
                      onClick={handleChangeiconDevPathSection}
                      style={{ cursor: 'pointer' }}>
                      <div
                        style={{
                          display: 'flex',
                          marginBottom: '14.4px',
                          alignItems: 'center',
                        }}>
                        <h4
                          style={{
                            fontFamily: 'L10',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '16px',
                            lineHeight: '18px',
                            letterSpacing: '0.0714286px',
                            marginBottom: '0.8rem',
                            margin: 0,
                          }}>
                          Development path
                        </h4>
                        <InformationIcon
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                          }}
                          background={false}
                          onMouseEnter={onHoverStep1Icon}
                          onMouseLeave={onLeaveStep1Icon}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setdevelopmentPathEditorInfo(true)
                          }}
                        />
                        <InformationModal2
                          InfoModalUL={`Here, you can formulate a development path based on the overall ideas presented in your scenario narrative. Consider the series of events that need to happen for your scenario to become a reality and map out the timeline (or vice versa). When listing the sequence of events, focus on the interrelations between the key drivers. The resulting development path and timeline will serve as key indicators for monitoring the future development of your scenario.`}
                          InfoModalUL2="Below is an example development path and timeline of a scenario where the level of foreign immigration in San Francisco remains the same, while the number of US residents seeking to own property in the city reaches an all-time high:"
                          InfoModalDescriptionA="2025: Increasing number of foreign companies seek to relocate to Silicon Valley due to its research and development advantages, while local companies mostly relocate to other states to reduce costs."
                          InfoModalDescriptionB="2028: The local government tries to attract American investors to purchase more land in San Francisco by offering tax waivers to its citizens."
                          InfoModalUL3="Caution! When mapping out a development path and timeline, it's important to avoid developing another scenario within a scenario. A clear description of each event within the timeline typically requires only 2-3 sentences, highlighting a few key actors. The more wordy the descriptions become, the more potential there is for confusion. Hence, in case you see many events taking place during the same year, it is advisable to split these into separate events."
                          // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                          // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                          // how many events are need in each scenario."
                          // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                          // style should be followed?"
                          InfoModalHeader={
                            'Development Path used in this scenario'
                          }
                          // InfoModalNote={
                          //   'A short and distinctive name to your scenario project'
                          // }
                          InfoModalOpen={developmentPathEditorInfo}
                          InfoModalClose={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setdevelopmentPathEditorInfo(false)
                          }}
                          // LearnMoreBtn={'How to write the scenario texts?'}
                          // GuideBtn={requestTranslation('GuideVotingBtn')}
                          // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                          // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                        />
                      </div>
                      <div>
                        <i className="material-icons">{iconDevPath}</i>
                      </div>
                    </Dropdown>
                    <div
                      id="collapsedevpaths"
                      className={` ${
                        iconDevPath === 'expand_more'
                          ? ' collapse show'
                          : ' collapse'
                      }`}>
                      <div className="form-group">
                        {/* <h4>Development Path</h4> */}
                        <div
                          className="d-flex flex-column"
                          style={{
                            fontfamily: 'L10',
                            fontStyle: 'normal',
                            fontweight: 500,
                            fontSize: '14px',
                            lineHeight: '20px',
                          }}>
                          <DevelopmentPath
                            value={values?.developmentPath}
                            // onChange={(value) => {
                            //   values.developmentPath = value
                            // }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {true && (
                  <div
                    className="modal-form-section"
                    style={{ zIndex: 2, position: 'relative' }}>
                    <div
                      style={{
                        zIndex: 999999,
                        position: 'absolute',
                        top: '35px',
                        right: '15%',
                      }}>
                      <ToggleSwitcher
                        isDeactivated={isMainActorsDeactivated}
                        type="mainActorsToogle"
                      />
                    </div>
                    <Dropdown
                      className="dropdown-toggle d-flex align-items-center justify-content-between"
                      type="button"
                      // data-toggle="collapse"
                      data-target="#collapseActors"
                      aria-expanded={
                        iconActors === 'expand_more' ? 'true' : 'false'
                      }
                      onClick={handleChangeiconActorsSection}
                      style={{ cursor: 'pointer' }}>
                      <div
                        style={{
                          display: 'flex',
                          marginBottom: '14.4px',
                          alignItems: 'center',
                        }}>
                        <h3
                          style={{
                            fontFamily: 'L10',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '20px',
                            lineHeight: '31px',
                            letterSpacing: '0.0928571px',
                            margin: 0,
                          }}
                          className="mb-0">
                          Main actors
                        </h3>
                        <InformationIcon
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                          }}
                          background={false}
                          onMouseEnter={onHoverStep1Icon}
                          onMouseLeave={onLeaveStep1Icon}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setmainActorsEditorInfo(true)
                          }}
                        />
                        <InformationModal2
                          InfoModalUL={`Main actors section represents the key companies, governments or other organisations that play a significant role in the scenario. Identifying the actors is important for monitoring purposes: this enables observing their potential activities that could indicate the world is developing towards the state described in the scenario.`}
                          // InfoModalDescription2="Instruct the division of work: who writes which scenario."
                          // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
                          // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
                          // InfoModalDescription5="For development paths, define how many events are need in each scenario."
                          // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                          // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                          // how many events are need in each scenario."
                          // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                          // style should be followed?"
                          InfoModalHeader={'Main actors used in this scenario'}
                          // InfoModalNote={
                          //   'A short and distinctive name to your scenario project'
                          // }
                          InfoModalOpen={mainActorsEditorInfo}
                          InfoModalClose={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setmainActorsEditorInfo(false)
                          }}
                          // LearnMoreBtn={'How to write the scenario texts?'}
                          // GuideBtn={requestTranslation('GuideVotingBtn')}
                          // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                          // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                        />
                      </div>
                      <div>
                        <i className="material-icons">{iconActors}</i>
                      </div>
                    </Dropdown>
                    <div id="collapsemainactors" className={`collapse mt-4}`}>
                      <div className="form-group">
                        <MainActors
                          isTitleNotShown={true}
                          mainActors={scenario?.mainActors}
                        />
                      </div>
                    </div>

                    <div
                      id="collapseActors"
                      className={` ${
                        iconActors === 'expand_more'
                          ? ' collapse show'
                          : ' collapse'
                      }`}>
                      <div className="form-group">
                        {/* <h4>Development Path</h4> */}
                        <div
                          className="d-flex flex-column"
                          style={{
                            fontfamily: 'L10',
                            fontStyle: 'normal',
                            fontweight: 500,
                            fontSize: '14px',
                            lineHeight: '20px',
                          }}>
                          <Actors
                            value={values?.actors}
                            // onChange={(value) => {
                            //   values.developmentPath = value
                            // }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {true && (
                  <div
                    className="modal-form-section"
                    style={{ zIndex: 1, position: 'relative' }}>
                    <div
                      style={{
                        zIndex: 999999,
                        position: 'absolute',
                        top: '36px',
                        right: '10%',
                        width: '370px',
                      }}>
                      <ToggleSwitcher
                        labelText={
                          'Show related scenarios on the scenario card'
                        }
                        isDeactivated={isRelatedScenariosDeactivated}
                        type="relatedScenariosToogle"
                      />
                    </div>

                    <Dropdown
                      className="dropdown-toggle d-flex align-items-center justify-content-between"
                      type="button"
                      // data-toggle="collapse"
                      data-target="#collapserelated_scenarios"
                      aria-expanded={
                        iconRelatedSSSection === 'expand_more'
                          ? 'true'
                          : 'false'
                      }
                      style={{ cursor: 'pointer' }}
                      onClick={handleChangeIconRelatedSSSection}>
                      <div
                        style={{
                          display: 'flex',
                          marginBottom: '14.4px',
                          alignItems: 'center',
                        }}>
                        <h3
                          className="mb-0"
                          style={{
                            fontFamily: 'L10',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '20px',
                            lineHeight: '31px',
                            letterSpacing: '0.0928571px',
                            margin: 0,
                          }}>
                          {/* {requestTranslation('relatedPhenomena')} */}
                          Related scenarios
                          <DropdownValue>
                            {values?.relatedScenarios?.length
                              ? ' : YES'
                              : ' : NO'}
                          </DropdownValue>
                        </h3>

                        <InformationIcon
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                          }}
                          background={false}
                          onMouseEnter={onHoverStep1Icon}
                          onMouseLeave={onLeaveStep1Icon}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setrelatedScenariosEditorInfo(true)
                          }}
                        />
                        <InformationModal2
                          InfoModalUL={`Here you can link scenarios from Futures Platform database which are related to this scenario. The other scenarios in this scenario set will automatically be added so you don’t need to add them.`}
                          // InfoModalDescription2="Instruct the division of work: who writes which scenario."
                          // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
                          // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
                          // InfoModalDescription5="For development paths, define how many events are need in each scenario."
                          // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                          // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                          // how many events are need in each scenario."
                          // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                          // style should be followed?"
                          InfoModalHeader={
                            'Related scenarios used in this scenario'
                          }
                          // InfoModalNote={
                          //   'A short and distinctive name to your scenario project'
                          // }
                          InfoModalOpen={relatedScenariosEditorInfo}
                          InfoModalClose={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setrelatedScenariosEditorInfo(false)
                          }}
                          // LearnMoreBtn={'How to write the scenario texts?'}
                          // GuideBtn={requestTranslation('GuideVotingBtn')}
                          // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                          // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                        />
                      </div>
                      <div>
                        <i className="material-icons">{iconRelatedSSSection}</i>
                      </div>
                    </Dropdown>
                    <div
                      id="collapserelated_scenarios"
                      className={`  mt-4 ${
                        iconRelatedSSSection === 'expand_more'
                          ? ' collapse show'
                          : ' collapse'
                      }`}>
                      <div style={{ overflow: 'hidden' }} className="row">
                        <div className="col-12 col-md-4">
                          {values?.relatedScenarios?.length > 0 && (
                            <SortableRelatedPhenomenaList
                              relatedPhenomena={values.relatedScenarios}
                              onSelect={toggleRelatedScenarios}
                              onSortEnd={setRelatedScenariosSort}
                            />
                          )}
                          <p className={'description'}>Related scenarios</p>
                        </div>
                        <div className="col-12 col-md-8" style={{ padding: 0 }}>
                          <RelatedPhenomena>
                            <ScenariosSelector
                              small
                              gid={gid}
                              phenomena={[]}
                              listView={false}
                              selectedPhenomena={
                                values.relatedScenarios ||
                                relatedScenarios ||
                                []
                              }
                              language={values?.language || language || 'en'}
                              radarId={false}
                              onSelect={toggleRelatedScenarios}
                              filter={false}
                              group={values?.group || gid}
                              // createOrEditMode={createOrEditMode}
                            />
                          </RelatedPhenomena>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {true && (
                  <div className="modal-form-section">
                    <Dropdown
                      className="dropdown-toggle d-flex align-items-center justify-content-between"
                      type="button"
                      // data-toggle="collapse"
                      data-target="#collapserelated_contents"
                      aria-expanded={
                        iconRelatedNodeSection === 'expand_more'
                          ? 'true'
                          : 'false'
                      }
                      style={{ cursor: 'pointer' }}
                      onClick={handleChangeIconRelatedNodesSection}>
                      <div
                        style={{
                          display: 'flex',
                          marginBottom: '14.4px',
                          alignItems: 'center',
                        }}>
                        <h3
                          className="mb-0"
                          style={{
                            fontFamily: 'L10',
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '20px',
                            lineHeight: '31px',
                            letterSpacing: '0.0928571px',
                            margin: 0,
                          }}>
                          {/* {requestTranslation('relatedPhenomena')} */}
                          Related content
                          <DropdownValue>
                            {!!relatedPhenomenaState?.length
                              ? // || !!relatedPhenomena?.length
                                ' : YES'
                              : ' : NO'}
                          </DropdownValue>
                        </h3>

                        <InformationIcon
                          style={{
                            marginTop: 0,
                            marginBottom: 0,
                          }}
                          background={false}
                          onMouseEnter={onHoverStep1Icon}
                          onMouseLeave={onLeaveStep1Icon}
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setrelatedContentsEditorInfo(true)
                          }}
                        />
                        <InformationModal2
                          InfoModalUL={`Here you can link phenomena from Futures Platform database which are related to this scenario. Identifying related phenomena is important for monitoring purposes: this enables observing their potential developments that could indicate the world is developing towards the state described in the scenario.`}
                          // InfoModalDescription2="Instruct the division of work: who writes which scenario."
                          // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
                          // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
                          // InfoModalDescription5="For development paths, define how many events are need in each scenario."
                          // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                          // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                          // how many events are need in each scenario."
                          // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                          // style should be followed?"
                          InfoModalHeader={
                            ' Related contents used in this scenario'
                          }
                          // InfoModalNote={
                          //   'A short and distinctive name to your scenario project'
                          // }
                          InfoModalOpen={relatedContentsEditorInfo}
                          InfoModalClose={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            setrelatedContentsEditorInfo(false)
                          }}
                          // LearnMoreBtn={'How to write the scenario texts?'}
                          // GuideBtn={requestTranslation('GuideVotingBtn')}
                          // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                          // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                        />
                      </div>
                      <div>
                        <i className="material-icons">
                          {iconRelatedNodeSection}
                        </i>
                      </div>
                    </Dropdown>
                    <div
                      id="collapserelated_contents"
                      className={`  mt-4 ${
                        iconRelatedNodeSection === 'expand_more'
                          ? ' collapse show'
                          : ' collapse'
                      }`}>
                      <div style={{ overflow: 'hidden' }} className="row">
                        <div className="col-12 col-md-4">
                          {values?.relatedPhenomena?.length > 0 && (
                            <SortableRelatedPhenomenaList
                              relatedPhenomena={values.relatedPhenomena}
                              onSelect={toggleRelatedPhenomenon}
                              onSortEnd={setRelatedPhenomenaSort}
                            />
                          )}
                          <p className={'description'}>
                            {requestTranslation('relatedPhenomenaText')}
                          </p>
                        </div>
                        <div className="col-12 col-md-8" style={{ padding: 0 }}>
                          <RelatedPhenomena>
                            <PhenomenaSelector
                              small
                              gid={gid}
                              phenomena={[]}
                              listView={false}
                              selectedPhenomena={
                                values?.relatedPhenomena ||
                                relatedPhenomena ||
                                []
                              }
                              language={values?.language || language || 'en'}
                              radarId={false}
                              onSelect={toggleRelatedPhenomenon}
                              filter={false}
                              group={values?.group || gid}
                              // createOrEditMode={createOrEditMode}
                            />
                          </RelatedPhenomena>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div
                  className="modal-form-section"
                  style={{ zIndex: 999999, position: 'relative' }}>
                  <div
                    style={{
                      zIndex: 999999,
                      position: 'absolute',
                      top: '36px',
                      right: '10%',
                      width: '280px',
                    }}>
                    <ToggleSwitcher
                      labelText={'Show tags on the scenario card'}
                      isDeactivated={isTagsDeactivated}
                      type="tagsToogle"
                    />
                  </div>
                  <Dropdown
                    className="dropdown-toggle d-flex align-items-center justify-content-between"
                    type="button"
                    // data-toggle="collapse"
                    data-target="#collapsetags"
                    aria-expanded={
                      iconTaggingSection === 'expand_more' ? 'true' : 'false'
                    }
                    onClick={handleChangeIconTagSection}
                    style={{ cursor: 'pointer' }}>
                    <div
                      style={{
                        display: 'flex',
                        marginBottom: '14.4px',
                        alignItems: 'center',
                      }}>
                      <h3
                        className="mb-0"
                        style={{
                          fontFamily: 'L10',
                          fontStyle: 'normal',
                          fontWeight: 700,
                          fontSize: '20px',
                          lineHeight: '31px',
                          letterSpacing: '0.0928571px',
                          margin: 0,
                        }}>
                        Tags:
                        <DropdownValue>
                          {!activeTagListStore?.length ? ' NO' : ' YES'}
                          {/* {
                                (!!editModal && editModal?.type === 'CREATE') 
                                  ? requestTranslation('hasNoTagged') 
                                  : ((!!phenomenonIncludesTagData?.tags  ? !!phenomenonIncludesTagData?.tags?.length :  !!storedPhenSelector?.tags?.length ) ? requestTranslation('hasTagged') : requestTranslation('hasNoTagged'))
                              } */}
                        </DropdownValue>
                      </h3>

                      <InformationIcon
                        style={{
                          marginTop: 0,
                          marginBottom: 0,
                        }}
                        background={false}
                        onMouseEnter={onHoverStep1Icon}
                        onMouseLeave={onLeaveStep1Icon}
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          settagsEditorInfo(true)
                        }}
                      />
                      <InformationModal2
                        InfoModalUL={`Adding tags helps contextualise your scenario and highlight its linkages to different industries, threats, opportunities, innovations, and other relevant categories. This can benefit your organisation, particularly if diversification or decision impact assessment is on the agenda.`}
                        // InfoModalDescription2="Instruct the division of work: who writes which scenario."
                        // InfoModalDescription3="Define how many paragraphs there should be in each narrative, and how long the paragraphs should be."
                        // InfoModalDescription4="Indicate what perspectives (3-6) all writers should cover when writing their scenario, and in which order those should appear. Perspectives can be e.g. General context, Economic development, or Impacts for the organisation."
                        // InfoModalDescription5="For development paths, define how many events are need in each scenario."
                        // InfoModalDescription6="You can include general instructions e.g what kind of writing style should be followed."
                        // InfoModalDescription7="If you aim to make development paths to scenarios, the facilitator should define clearly
                        // how many events are need in each scenario."
                        // InfoModalDescription8="You may also include general instructions for writing the scenarios e.g what kind of writing
                        // style should be followed?"
                        InfoModalHeader={'Tags used in this scenario'}
                        // InfoModalNote={
                        //   'A short and distinctive name to your scenario project'
                        // }
                        InfoModalOpen={tagsEditorInfo}
                        InfoModalClose={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          settagsEditorInfo(false)
                        }}
                        // LearnMoreBtn={'How to write the scenario texts?'}
                        // GuideBtn={requestTranslation('GuideVotingBtn')}
                        // LearnMoreLink="https://info.futuresplatform.com/en/hub/how-to-use-the-scenario-building-tool#write-the-narratives"
                        // GuideLink="https://info.futuresplatform.com/hub/how-to-orginise-voting"
                      />
                    </div>
                    {!isTagsDeactivated && (
                      <div>
                        <i className="material-icons">{iconTaggingSection}</i>
                      </div>
                    )}
                  </Dropdown>
                  <div
                    id="collapsetags"
                    className={`${
                      !!isTagsDeactivated ||
                      iconTaggingSection === 'expand_less'
                        ? 'collapse '
                        : ' collapse show '
                    } mt-4`}
                    style={{ position: 'relative' }}>
                    <div style={{ overflow: 'hidden' }} className="row">
                      <div
                        className="col-12 "
                        style={{
                          maxWidth: '50%',
                          height: 'auto',
                          minHeight: '300px',
                          height: 'fit-content',
                        }}>
                        <PhenomenaTagList
                          gid={gid}
                          scenario={{
                            id: scenario.id,
                            tags: Array.from(
                              !!activeTagListStore?.length
                                ? activeTagListStore
                                : [],
                            ),
                          }}
                          language={getLanguage() || 'en'}
                          // tagListt={activeTagListStore}
                        />
                        <div
                          style={{
                            display: 'flex',
                            // marginTop: '32px',
                            marginLeft: '-18px',
                            position: 'absolute',
                            bottom: 0,
                          }}>
                          {!!isTagsDeactivated && (
                            <Icon
                              path={
                                !isTaggingSelectorOpened
                                  ? mdiTagPlusOutline
                                  : mdiTagPlus
                              }
                              className={`fp-text-icon hoverable`}
                              size={1}
                              color={'#006998'}
                              style={{ position: 'relative', top: '1px' }}
                              onClick={toogleTaggingSelectorModal}
                            />
                          )}
                          {!isTagsDeactivated && (
                            <Icon
                              path={
                                !isTaggingSelectorOpened && !isTagsDeactivated
                                  ? mdiTagPlusOutline
                                  : mdiTagPlus
                              }
                              className={`fp-text-icon hoverable`}
                              size={1}
                              color={'#006998'}
                              style={{ position: 'relative', top: '1px' }}
                              onClick={toogleTaggingSelectorModal}
                            />
                          )}

                          <p
                            className={'description'}
                            style={{
                              fontWeight: 'bold',
                              fontSize: '14px',
                              color: '#006998',
                              textTransform: 'uppercase',
                            }}>
                            Add / remove tags
                          </p>
                        </div>
                      </div>
                      {isTaggingSelectorOpened && (
                        <PhenomenaTagSelector
                          toogleTaggingSelectorModal={
                            toogleTaggingSelectorModalToClose
                          }
                          lang={getLanguage() || ''}
                          gid={gid}
                          activeTagList={activeTagListStore}
                          dispatch={dispatch}
                          mutateTagsScenarioData={mutateTagsScenarioData}
                          contentTargetId={scenario?.id}
                          // addTagHandler={tagScenario}
                          // removeTagHandler={removeTagScenario}
                          // contentType="scenario"
                          // phenomenon={{
                          //   id: scenario.id,
                          //   position: { x: 350, y: -300 },
                          //   tags: Array.from(tags),
                          // }}
                          // handlePhenomenaTagMod={(tag, phenomenon, group) => {
                          //   addOrRemoveTag(tag.uri)
                          // }}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="modal-form-section">
                  <Dropdown
                    className="dropdown-toggle d-flex align-items-center justify-content-between"
                    type="button"
                    // data-toggle="collapse"
                    data-target="#collapsehistory"
                    aria-expanded={
                      iconHistorySection === 'expand_more' ? 'true' : 'false'
                    }
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={handleChangeIconHistorySection}>
                    <h3
                      className="mb-0"
                      style={{
                        fontSize: '20px',
                        fontWeight: 700,
                      }}>
                      {requestTranslation('Historyandchangelog')}
                    </h3>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <p
                        style={{
                          margin: 0,
                          marginRight: '24px',
                          fontWeight: '100',
                        }}>
                        {iconHistorySection === 'expand_more'
                          ? requestTranslation('ShowHistory')
                          : requestTranslation('HideHistory')}
                      </p>
                      <i className="material-icons">{iconHistorySection}</i>
                    </div>
                  </Dropdown>
                  <Modal
                    isOpen={isEditHistoryModalOpened}
                    onRequestClose={() => onCloseEditingHistory()}
                    style={paddingModalStyles}
                    ariaHideApp={false}>
                    <div className="modal-form-sections">
                      <div
                        className="modal-form-section modal-form-header"
                        style={{ paddingBottom: '1px' }}>
                        <h3>{requestTranslation('editHistory')}</h3>
                      </div>
                      <div
                        id="history-content-card-editor"
                        className="modal-form-section"
                        style={{ paddingTop: 0, cursor: 'pointer' }}>
                        <div
                          className="form-group"
                          style={{
                            zIndex: 999999,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                          }}>
                          <p
                            style={{
                              margin: 0,
                              marginRight: '1.5rem',
                              width: '100px',
                            }}>
                            {historyDataState[currentIndexEditingHistory]
                              ?.isMajorUpdate
                              ? requestTranslation('createdby')
                              : requestTranslation('editOn')}
                          </p>
                          <div>
                            <DatePicker
                              wrapperClassName="datepicker"
                              dateFormat="dd.MM.yyyy"
                              // style={{ width: "60% !important" }}
                              selected={
                                new Date(
                                  `${
                                    {
                                      ...historyDataState[
                                        currentIndexEditingHistory
                                      ],
                                    }?.date?.split('.')[1]
                                  }/${
                                    {
                                      ...historyDataState[
                                        currentIndexEditingHistory
                                      ],
                                    }?.date?.split('.')[0]
                                  }/${
                                    {
                                      ...historyDataState[
                                        currentIndexEditingHistory
                                      ],
                                    }?.date?.split('.')[2]
                                  }`,
                                )
                              }
                              onChange={(date) => {
                                const temp = [...historyDataState]
                                const dayTemp = date.getDate()
                                const monthTemp = date.getMonth() + 1
                                const yearTemp = date.getFullYear()
                                const temp2 =
                                  dayTemp + '.' + monthTemp + '.' + yearTemp
                                const temp3 = {
                                  ...temp[currentIndexEditingHistory],
                                }

                                temp3['date'] = temp2
                                temp[currentIndexEditingHistory] = { ...temp3 }
                                sethistoryDataState(() => [...temp])
                              }}
                              className=" ml-4"
                              placeholderText={requestTranslation('chooseDate')}
                              minDate={null}
                              maxDate={null}
                            />
                          </div>
                          <p
                            style={{
                              margin: 0,
                              marginRight: '1.5rem',
                              marginLeft: '1.5rem',
                            }}>
                            {requestTranslation('by')}
                          </p>
                          <input
                            style={{
                              width:
                                'calc(100% - (100px + 1.5rem + 125px + 2rem + 15.68px + 1.6px + 1.6px +  1.6px + 1%))',
                              height: '44px',
                              padding: '16px',
                            }}
                            value={
                              Number(gid) !== 0
                                ? historyDataState[currentIndexEditingHistory]
                                    ?.editorName
                                : 'Futures Platform'
                            }
                            onChange={userNameEdtingHistoryHandler}
                            onPaste={handlePaste}
                            onBlur={userNameEdtingHistorySanitize}
                          />
                        </div>

                        <div
                          className="form-group"
                          style={{
                            display: 'flex',
                            width: '100%',
                          }}>
                          <p
                            style={{
                              marginRight: '1.5rem',
                              width: '100px',
                            }}>
                            {requestTranslation('Description')}
                          </p>
                          <textarea
                            style={{
                              width: 'calc(100% - (1.5rem + 100px + 1.6px))',
                              fontSize: '13px',
                              resize: 'vertical',
                              overflowY: 'auto',
                              height: '100px',
                              margin: 0,
                            }}
                            value={
                              historyDataState[currentIndexEditingHistory]
                                ?.description ?? ''
                            }
                            onChange={descriptionEdtingHistoryHandler}
                            onPaste={handlePaste}
                            onBlur={descriptionEdtingHistorySanitize}
                            // maxLength="1000" type="text" className={clsx(styles.textAreaStyle,"form-control")} id='comment_textarea' value={valueInput ?? ''} placeholder={'Message *'}
                          />
                        </div>
                      </div>
                    </div>

                    <ButtonsContainer
                      className={'modal-form-section modal-form-actions'}>
                      <button
                        className="btn btn-lg btn-plain-gray"
                        onClick={() => {
                          // setPhenomenonToTag(false)
                          onCloseEditingHistory()
                        }}>
                        {requestTranslation('cancel')}
                      </button>
                      <button
                        className="btn btn-lg btn-primary"
                        onClick={() => {
                          // setPhenomenonToTag(false)
                          // dispatch({
                          //   type: ACTIONS.CURRENTINDEXEDITINGHISTORY,
                          //   payload: -99
                          // })
                          setisEditHistoryModalOpened(false)
                        }}
                        // type="submit"
                        disabled={isSubmitting || !isValid}>
                        {requestTranslation('save')}
                      </button>
                    </ButtonsContainer>
                  </Modal>

                  <div
                    id="collapsehistory"
                    className={`${
                      iconHistorySection === 'expand_less'
                        ? ' collapse '
                        : ' collapse show '
                    } mt-4`}>
                    {!!historyDataState?.length &&
                      [...historyDataState]
                        ?.sort((a, b) => b?.timestamp - a?.timestamp)
                        ?.map((h, i) => {
                          return (
                            <HistoryEditor
                              gid={gid}
                              isShowDeleteHistoryModal={
                                isShowDeleteHistoryModal
                              }
                              setisShowDeleteHistoryModal={
                                setisShowDeleteHistoryModal
                              }
                              closeModal={() =>
                                setisEditHistoryModalOpened(false)
                              }
                              openModal={() =>
                                setisEditHistoryModalOpened(true)
                              }
                              isEditHistoryModalOpened={
                                isEditHistoryModalOpened
                              }
                              key={h?.id}
                              history={h}
                              index={i}
                              historyDataState={historyDataState}
                              sethistoryDataState={sethistoryDataState}
                            />
                          )
                        })}
                  </div>
                </div>

                <div className="modal-form-section">
                  <Dropdown
                    className="dropdown-toggle d-flex align-items-center justify-content-between"
                    type="button"
                    // data-toggle="collapse"
                    data-target="#collapsehistory-major-update"
                    aria-expanded={
                      iconHistoryMajorUpdateSection === 'expand_more'
                        ? 'true'
                        : 'false'
                    }
                    style={{ cursor: 'pointer' }}
                    onClick={
                      !!majorUpdate?.isMajorUpdate
                        ? handleChangeIconHistoryMajorSection
                        : null
                    }>
                    <h3
                      className="mb-0"
                      style={{
                        fontSize: '20px',
                      }}>
                      {requestTranslation('DescriptionMajorChangeLogs')}
                    </h3>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <p
                        style={{
                          margin: 0,
                          marginRight: '24px',
                          fontWeight: '100',
                        }}>
                        {requestTranslation('ShowAsMajorUpdate')}
                      </p>
                      <div style={{ marginRight: '24px' }}>
                        <ToggleSwitcherForHistory
                          checked={majorUpdate?.isMajorUpdate}
                          toggleHandler={() => {
                            if (!!majorUpdate?.isMajorUpdate)
                              seticonHistoryMajorUpdateSection(
                                () => `expand_less`,
                              )
                            else {
                              seticonHistoryMajorUpdateSection(
                                () => `expand_more`,
                              )
                            }
                            setmajorUpdate(() => {
                              return {
                                description: !!majorUpdate?.isMajorUpdate
                                  ? majorUpdate?.description
                                  : '',
                                isMajorUpdate: !majorUpdate?.isMajorUpdate,
                              }
                            })
                          }}
                        />
                      </div>
                      <i className="material-icons">
                        {iconHistoryMajorUpdateSection}
                      </i>
                    </div>
                  </Dropdown>
                  <div
                    id="collapsehistory-major-update"
                    className={`collapse mt-4 ${
                      iconHistoryMajorUpdateSection === 'expand_more'
                        ? ' collapse show '
                        : ' collapse '
                    }`}>
                    {!!majorUpdate?.isMajorUpdate && (
                      <textarea
                        id="111111"
                        disabled={!majorUpdate?.isMajorUpdate}
                        onChange={(e) => {
                          setmajorUpdate(() => {
                            const temp = e.target.value
                            return {
                              description: temp,
                              isMajorUpdate: majorUpdate?.isMajorUpdate,
                            }
                          })
                        }}
                        value={majorUpdate?.description}
                        style={{
                          minHeight: '100px',
                        }}
                        rows={4}
                        placeholder="Write here a brief description why this should be considered as major update."
                      />
                    )}
                  </div>
                </div>

                <div className="modal-form-section">
                  <CardFooter
                    data={data}
                    scenarioId={data.scenarioCard?.id}
                    lang={getLanguage() || 'en'}
                    gid={gid}
                    isEditBtnShown={false}
                  />
                </div>
              </div>
              <BtnWrapper
                className={'modal-form-section modal-form-actions'}
                style={{ alignItems: 'center' }}>
                <button
                  style={{ paddingLeft: 0, fontSize: '17px' }}
                  className="btn  btn-plain-red btn-lg"
                  onClick={() => setisDeleteModalOpened(true)}>
                  Remove
                </button>
                <ButtonsContainer>
                  <button
                    style={{
                      fontSize: '15px',
                      paddingBottom: '13px',
                      paddingTop: '13px',
                    }}
                    className="btn btn-outline-secondary btn-lg"
                    onClick={() => onReview(values)}>
                    Preview
                  </button>
                  <button
                    style={{
                      fontSize: '16.5px',
                    }}
                    className="btn  btn-plain-gray btn-lg"
                    onClick={onCancel}>
                    CANCEL
                  </button>
                  <button
                    id="submitSaveBtn"
                    style={{
                      fontSize: '16.5px',
                      paddingTop: '8px',
                      paddingBottom: '8px',
                      opacity: `${!errors?.title ? 1 : '0.65'}`,
                    }}
                    className="btn btn-primary btn-lg"
                    onClick={() => {
                      if (!!errors?.title) {
                        document.querySelector('#title')?.scrollIntoView({
                          behavior: 'smooth',
                          block: 'center',
                          inline: 'center',
                        })
                        document.querySelector('#title')?.focus()
                      } else handleSubmit()
                      // saveScenario(values)
                    }}
                    type="submit"
                    disabled={isSubmitting || (!isValid && !errors?.title)}>
                    {'SAVE'}
                  </button>
                </ButtonsContainer>
              </BtnWrapper>
            </div>
          )
        }}
      </Formik>
    </>
  )
}

const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-between !important;
`
export const BlueBtn = styled.button`
  width: fit-content;
  height: 34px;
  color: #006998;
  border-color: #006998
  cursor: pointer;
  padding-top: 4px;
    padding-bottom: 4px !important;
  &:hover {
    color: #fff ;
    background-color: #006998 ;
    border-color: #006998 ;
  }
`

export const SelectImageInputCustom = styled.input`
  z-index: 20;
  width: 100%;
  height: 100%;
  opacity: 0;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  color: #006998;
  border-color: #006998;
  cursor: pointer;
  &:hover {
    color: #fff !important;
    background-color: #006998 !important;
    border-color: #006998 !important;
  }import History from '../History/index';

`
const SelectImageInputContainerCustom = styled.button`
width: 'fit-content';
  height: 'fit-content';
  color: #006998;
  border-color: #006998
  cursor: pointer;
  &:hover {
    color: #fff ;
    background-color: #006998 ;
    border-color: #006998 ;
  }
`
export const DropdownValue = styled.span`
  font-size: 14px;
  margin-left: 8px;
`

const Dropdown = styled.div`
  -webkit-appearance: none;
  &:after {
    display: none;
  }
`

const Textarea = styled.textarea`
  font-size: 14px;
  min-height: 150px;
  border-radius: 1px;
`

const RadarImageCloseContainer = styled.div`
  position: absolute;
  top: -15px;
  right: -15px;
  border-radius: 50%;
  background-color: #f1f3f3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid gray;
  &:hover {
    cursor: pointer;
  }
`

const RadarImageClose = styled.i`
  /*color: gray;*/
  opacity: 0.7;
`

const DeleteRowButton = styled.button`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1px solid red;
  color: red;
  font-size: 14px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`

const CloseIcon = styled.i`
  font-size: 14px;
  font-weight: 700;
  &:hover {
    cursor: pointer;
  }
`

const RelatedPhenomena = styled.div`
  height: 300px;
  display: flex;
  flex-direction: column;
`

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

WriteEditScenarioForm.propTypes = {
  phenomenon: PropTypes.object,
  radar: PropTypes.shape({
    id: PropTypes.string.isRequired,
    groupId: PropTypes.number.isRequired,
    language: PropTypes.string.isRequired,
  }),
  // onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

const InformationIcon = styled(InfoCircle)`
  background-color: ${(props) =>
    props.background ? '#f1f3f3' : 'transparent'};
  color: #666;
  width: 18px;
  height: 18px;
  margin-top: 65px;
  margin-bottom: 14px;
  margin-left: 18px;
  &:hover {
    cursor: pointer;
    color: #64cdef;
  }
`
